import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import theme from '../theme';
import fn from '../../helpers/fn';

const data = {
  status: 'success',
  response_code: 200,
  resource: 'locations',
  action: 'index',
  message: 'success',
  data: {
    locations: [
      {
        location: {
          id: 503,
          label: 'Johannesburg',
          stream_supported: true,
          latitude: '-26.2',
          longitude: '28.0833',
          country: 'ZA',
          country_name: 'South Africa',
          continent: '015',
          continent_name: 'Africa',
        },
      },
      {
        location: {
          id: 502,
          label: 'Bogota',
          stream_supported: false,
          latitude: '4.6',
          longitude: '-74.0833',
          country: 'CO',
          country_name: 'Colombia',
          continent: '005',
          continent_name: 'South America',
        },
      },
      {
        location: {
          id: 501,
          label: 'Yungho',
          stream_supported: false,
          latitude: '25',
          longitude: '121.496',
          country: 'TW',
          country_name: 'Taiwan',
          continent: '142',
          continent_name: 'Asia',
        },
      },
      {
        location: {
          id: 500,
          label: 'Bangalore',
          stream_supported: true,
          latitude: '12.9833',
          longitude: '77.5833',
          country: 'IN',
          country_name: 'India',
          continent: '142',
          continent_name: 'Asia',
        },
      },
      {
        location: {
          id: 477,
          label: 'Palmerston North',
          stream_supported: false,
          latitude: '-40.35',
          longitude: '175.617',
          country: 'NZ',
          country_name: 'New Zealand',
          continent: '009',
          continent_name: 'Oceania',
        },
      },
      {
        location: {
          id: 421,
          label: 'Bucharest',
          stream_supported: false,
          latitude: '44.4333',
          longitude: '26.1',
          country: 'RO',
          country_name: 'Romania',
          continent: '150',
          continent_name: 'Europe',
        },
      },
      {
        location: {
          id: 414,
          label: 'Krasnoyarsk',
          stream_supported: false,
          latitude: '56.0097',
          longitude: '92.7917',
          country: 'RU',
          country_name: 'Russia',
          continent: '150',
          continent_name: 'Europe',
        },
      },
      {
        location: {
          id: 400,
          label: 'Provo',
          stream_supported: false,
          latitude: '40.2339',
          longitude: '-111.658',
          country: 'US',
          country_name: 'United States',
          continent: '003',
          continent_name: 'North America',
        },
      },
      {
        location: {
          id: 386,
          label: 'Dubai',
          stream_supported: false,
          latitude: '25.2522',
          longitude: '55.28',
          country: 'AE',
          country_name: 'United Arab Emirates',
          continent: '142',
          continent_name: 'Asia',
        },
      },
      {
        location: {
          id: 379,
          label: 'Seattle',
          stream_supported: true,
          latitude: '47.6064',
          longitude: '-122.331',
          country: 'US',
          country_name: 'United States',
          continent: '003',
          continent_name: 'North America',
        },
      },
      {
        location: {
          id: 372,
          label: 'Miami',
          stream_supported: true,
          latitude: '25.7739',
          longitude: '-80.1939',
          country: 'US',
          country_name: 'United States',
          continent: '003',
          continent_name: 'North America',
        },
      },
      {
        location: {
          id: 365,
          label: 'Paris II',
          stream_supported: false,
          latitude: '48.8667',
          longitude: '2.33333',
          country: 'FR',
          country_name: 'France',
          continent: '150',
          continent_name: 'Europe',
        },
      },
      {
        location: {
          id: 358,
          label: 'Dallas II',
          stream_supported: false,
          latitude: '32.7833',
          longitude: '-96.8',
          country: 'US',
          country_name: 'United States',
          continent: '003',
          continent_name: 'North America',
        },
      },
      {
        location: {
          id: 351,
          label: 'Melbourne',
          stream_supported: false,
          latitude: '-37.8167',
          longitude: '144.967',
          country: 'AU',
          country_name: 'Australia',
          continent: '009',
          continent_name: 'Oceania',
        },
      },
      {
        location: {
          id: 344,
          label: 'Queretaro',
          stream_supported: false,
          latitude: '20.6',
          longitude: '-100.383',
          country: 'MX',
          country_name: 'Mexico',
          continent: '003',
          continent_name: 'North America',
        },
      },
      {
        location: {
          id: 260,
          label: 'Buenos Aires',
          stream_supported: false,
          latitude: '-34.6033',
          longitude: '-58.3817',
          country: 'AR',
          country_name: 'Argentina',
          continent: '005',
          continent_name: 'South America',
        },
      },
      {
        location: {
          id: 134,
          label: 'Atlanta',
          stream_supported: true,
          latitude: '33.7489',
          longitude: '-84.3881',
          country: 'US',
          country_name: 'United States',
          continent: '003',
          continent_name: 'North America',
        },
      },
      // {
      //   location: {
      //     id: 130,
      //     label: 'Tokyo',
      //     stream_supported: false,
      //     latitude: '35.685',
      //     longitude: '139.751',
      //     country: 'JP',
      //     country_name: 'Japan',
      //     continent: '142',
      //     continent_name: 'Asia',
      //   },
      // },
      {
        location: {
          id: 129,
          label: 'San Jose',
          stream_supported: false,
          latitude: '37.3394',
          longitude: '-121.894',
          country: 'US',
          country_name: 'United States',
          continent: '003',
          continent_name: 'North America',
        },
      },
      {
        location: {
          id: 125,
          label: 'Ho Chi Minh City',
          stream_supported: false,
          latitude: '10.75',
          longitude: '106.667',
          country: 'VN',
          country_name: 'Vietnam',
          continent: '142',
          continent_name: 'Asia',
        },
      },
      {
        location: {
          id: 121,
          label: 'Delhi',
          stream_supported: true,
          latitude: '28.6667',
          longitude: '77.2167',
          country: 'IN',
          country_name: 'India',
          continent: '142',
          continent_name: 'Asia',
        },
      },
      {
        location: {
          id: 108,
          label: 'Trondheim',
          stream_supported: false,
          latitude: '63.4167',
          longitude: '10.4167',
          country: 'NO',
          country_name: 'Norway',
          continent: '150',
          continent_name: 'Europe',
        },
      },
      {
        location: {
          id: 104,
          label: 'New York',
          stream_supported: true,
          latitude: '40.7142',
          longitude: '-74.0064',
          country: 'US',
          country_name: 'United States',
          continent: '003',
          continent_name: 'North America',
        },
      },
      {
        location: {
          id: 99,
          label: 'Odessa',
          stream_supported: false,
          latitude: '46.4846',
          longitude: '30.7326',
          country: 'UA',
          country_name: 'Ukraine',
          continent: '150',
          continent_name: 'Europe',
        },
      },
      {
        location: {
          id: 88,
          label: 'Oslo',
          stream_supported: false,
          latitude: '59.9167',
          longitude: '10.75',
          country: 'NO',
          country_name: 'Norway',
          continent: '150',
          continent_name: 'Europe',
        },
      },
      {
        location: {
          id: 87,
          label: 'Montreal',
          stream_supported: false,
          latitude: '45.5',
          longitude: '-73.5833',
          country: 'CA',
          country_name: 'Canada',
          continent: '003',
          continent_name: 'North America',
        },
      },
      {
        location: {
          id: 77,
          label: 'Washington',
          stream_supported: false,
          latitude: '38.895',
          longitude: '-77.0367',
          country: 'US',
          country_name: 'United States',
          continent: '003',
          continent_name: 'North America',
        },
      },
      {
        location: {
          id: 74,
          label: 'Athens',
          stream_supported: false,
          latitude: '37.9833',
          longitude: '23.7333',
          country: 'GR',
          country_name: 'Greece',
          continent: '150',
          continent_name: 'Europe',
        },
      },
      {
        location: {
          id: 71,
          label: 'Copenhagen',
          stream_supported: true,
          latitude: '55.6667',
          longitude: '12.5833',
          country: 'DK',
          country_name: 'Denmark',
          continent: '150',
          continent_name: 'Europe',
        },
      },
      {
        location: {
          id: 69,
          label: 'Madrid',
          stream_supported: true,
          latitude: '40.4',
          longitude: '-3.68333',
          country: 'ES',
          country_name: 'Spain',
          continent: '150',
          continent_name: 'Europe',
        },
      },
      {
        location: {
          id: 65,
          label: 'Milan',
          stream_supported: false,
          latitude: '45.4667',
          longitude: '9.2',
          country: 'IT',
          country_name: 'Italy',
          continent: '150',
          continent_name: 'Europe',
        },
      },
      {
        location: {
          id: 63,
          label: 'Kharkov',
          stream_supported: false,
          latitude: '49.9935',
          longitude: '36.2304',
          country: 'UA',
          country_name: 'Ukraine',
          continent: '150',
          continent_name: 'Europe',
        },
      },
      {
        location: {
          id: 58,
          label: 'Singapore',
          stream_supported: false,
          latitude: '1.29306',
          longitude: '103.856',
          country: 'SG',
          country_name: 'Singapore',
          continent: '142',
          continent_name: 'Asia',
        },
      },
      {
        location: {
          id: 55,
          label: 'Seoul',
          stream_supported: false,
          latitude: '37.5664',
          longitude: '127',
          country: 'KR',
          country_name: 'South Korea',
          continent: '142',
          continent_name: 'Asia',
        },
      },
      {
        location: {
          id: 50,
          label: 'Atlanta II',
          stream_supported: false,
          latitude: '33.7489',
          longitude: '-84.3881',
          country: 'US',
          country_name: 'United States',
          continent: '003',
          continent_name: 'North America',
        },
      },
      {
        location: {
          id: 48,
          label: 'Hanoi',
          stream_supported: true,
          latitude: '21.0333',
          longitude: '105.85',
          country: 'VN',
          country_name: 'Vietnam',
          continent: '142',
          continent_name: 'Asia',
        },
      },
      {
        location: {
          id: 46,
          label: 'Istanbul',
          stream_supported: false,
          latitude: '41.0186',
          longitude: '28.9647',
          country: 'TR',
          country_name: 'Turkey',
          continent: '150',
          continent_name: 'Europe',
        },
      },
      {
        location: {
          id: 45,
          label: 'Lvov',
          stream_supported: false,
          latitude: '49.8333',
          longitude: '24',
          country: 'UA',
          country_name: 'Ukraine',
          continent: '150',
          continent_name: 'Europe',
        },
      },
      {
        location: {
          id: 44,
          label: 'Frankfurt',
          stream_supported: true,
          latitude: '50.1167',
          longitude: '8.68333',
          country: 'DE',
          country_name: 'Germany',
          continent: '150',
          continent_name: 'Europe',
        },
      },
      {
        location: {
          id: 42,
          label: 'Sydney',
          stream_supported: false,
          latitude: '-33.8833',
          longitude: '151.217',
          country: 'AU',
          country_name: 'Australia',
          continent: '009',
          continent_name: 'Oceania',
        },
      },
      {
        location: {
          id: 41,
          label: 'Perth',
          stream_supported: false,
          latitude: '-31.9333',
          longitude: '115.833',
          country: 'AU',
          country_name: 'Australia',
          continent: '009',
          continent_name: 'Oceania',
        },
      },
      {
        location: {
          id: 39,
          label: 'Taipei',
          stream_supported: true,
          latitude: '25.0392',
          longitude: '121.525',
          country: 'TW',
          country_name: 'Taiwan',
          continent: '142',
          continent_name: 'Asia',
        },
      },
      {
        location: {
          id: 34,
          label: 'Sao Paulo',
          stream_supported: true,
          latitude: '-23.5333',
          longitude: '-46.6167',
          country: 'BR',
          country_name: 'Brazil',
          continent: '005',
          continent_name: 'South America',
        },
      },
      {
        location: {
          id: 31,
          label: 'Amsterdam',
          stream_supported: false,
          latitude: '52.35',
          longitude: '4.91667',
          country: 'NL',
          country_name: 'Netherlands',
          continent: '150',
          continent_name: 'Europe',
        },
      },
      {
        location: {
          id: 27,
          label: 'Dallas',
          stream_supported: true,
          latitude: '32.7833',
          longitude: '-96.8',
          country: 'US',
          country_name: 'United States',
          continent: '003',
          continent_name: 'North America',
        },
      },
      {
        location: {
          id: 26,
          label: 'Toronto',
          stream_supported: false,
          latitude: '43.6667',
          longitude: '-79.4167',
          country: 'CA',
          country_name: 'Canada',
          continent: '003',
          continent_name: 'North America',
        },
      },
      {
        location: {
          id: 25,
          label: 'Paris',
          stream_supported: true,
          latitude: '48.8667',
          longitude: '2.33333',
          country: 'FR',
          country_name: 'France',
          continent: '150',
          continent_name: 'Europe',
        },
      },
      {
        location: {
          id: 23,
          label: 'Chicago',
          stream_supported: false,
          latitude: '41.85',
          longitude: '-87.65',
          country: 'US',
          country_name: 'United States',
          continent: '003',
          continent_name: 'North America',
        },
      },
      {
        location: {
          id: 19,
          label: 'Moscow',
          stream_supported: true,
          latitude: '55.7522',
          longitude: '37.6156',
          country: 'RU',
          country_name: 'Russia',
          continent: '150',
          continent_name: 'Europe',
        },
      },
      {
        location: {
          id: 16,
          label: 'Kiev',
          stream_supported: false,
          latitude: '50.4333',
          longitude: '30.5167',
          country: 'UA',
          country_name: 'Ukraine',
          continent: '150',
          continent_name: 'Europe',
        },
      },
      {
        location: {
          id: 14,
          label: 'Seattle II',
          stream_supported: false,
          latitude: '47.6064',
          longitude: '-122.331',
          country: 'US',
          country_name: 'United States',
          continent: '003',
          continent_name: 'North America',
        },
      },
      {
        location: {
          id: 13,
          label: 'London',
          stream_supported: true,
          latitude: '51.5',
          longitude: '-0.116667',
          country: 'GB',
          country_name: 'United Kingdom',
          continent: '150',
          continent_name: 'Europe',
        },
      },
      {
        location: {
          id: 11,
          label: 'Hong Kong',
          stream_supported: false,
          latitude: '22.2833',
          longitude: '114.15',
          country: 'HK',
          country_name: 'Hong Kong SAR China',
          continent: '142',
          continent_name: 'Asia',
        },
      },
      {
        location: {
          id: 10,
          label: 'Stockholm',
          stream_supported: true,
          latitude: '59.3333',
          longitude: '18.05',
          country: 'SE',
          country_name: 'Sweden',
          continent: '150',
          continent_name: 'Europe',
        },
      },
      {
        location: {
          id: 8,
          label: 'Budapest',
          stream_supported: false,
          latitude: '47.5',
          longitude: '19.0833',
          country: 'HU',
          country_name: 'Hungary',
          continent: '150',
          continent_name: 'Europe',
        },
      },
      {
        location: {
          id: 7,
          label: 'Denver',
          stream_supported: false,
          latitude: '39.7392',
          longitude: '-104.984',
          country: 'US',
          country_name: 'United States',
          continent: '003',
          continent_name: 'North America',
        },
      },
      {
        location: {
          id: 4,
          label: 'Los Angeles',
          stream_supported: true,
          latitude: '34.0522',
          longitude: '-118.243',
          country: 'US',
          country_name: 'United States',
          continent: '003',
          continent_name: 'North America',
        },
      },
    ],
  },
};

const angle = -45 * (Math.PI / 180);
const radius = 75; // %

const getPoint = ({ latitude, longitude }) => {
  const mapWidth = 940;
  const mapHeight = mapWidth * 0.495744681;
  const mapOffsetX = -42;
  const mapOffsetY = 36.5;
  const mapScaleX = 1.375;
  const mapScaleY = 2.63;

  // Convert from degrees to radians.
  const latRad = parseFloat(latitude) * -(Math.PI / 180);
  const lonRad = parseFloat(longitude) * (Math.PI / 180);

  // Kavrayskiy VII projection.
  let x = (lonRad === 0 ?
    0 :
    ((3 * lonRad) / (Math.PI * 2)) * Math.sqrt(((Math.PI ** 2) / 3) - (latRad ** 2))
  );
  let y = latRad;

  // Scale to fit map.
  x *= (mapWidth * mapScaleX) / (Math.PI * 2);
  y *= (mapHeight * mapScaleY) / (Math.PI * 2);

  // Calculate from center of map.
  x += (mapWidth / 2) + mapOffsetX;
  y += (mapHeight / 2) + mapOffsetY;
  return {
    x: x / mapWidth,
    y: y / mapHeight,
  };
};

const Map = ({ className }) => (
  <div className={className}>
    <svg
      style={{
        width: '100%',
        height: '100%',
      }}
      viewBox="-256.839 -127.234 940 465.637"
    >
      <defs>
        <linearGradient
          id="MapGradient"
          x1={`${50 + (Math.sin(angle) * radius)}%`}
          y1={`${50 + (Math.cos(angle) * radius)}%`}
          x2={`${50 + (Math.sin(angle + Math.PI) * radius)}%`}
          y2={`${50 + (Math.cos(angle + Math.PI) * radius)}%`}
        >
          <stop className="stop1" offset="0%" />
          <stop className="stop2" offset="100%" />
        </linearGradient>
      </defs>
      <path
        fill="url(#MapGradient)"
        d="M-164.942-96.061c0.088-0.035,0.132-0.068,0.132-0.093C-164.81-96.308-164.871-96.222-164.942-96.061z
        M58.624,164.995c0,0-4.212-0.878-4.395-1.405c-0.174-0.525-7.379-6.849-7.544-6.673c-0.187,0.172-2.997-2.823-3.35-1.934
        c-0.344,0.878-5.795,0.878-5.795,0.878l-5.798-1.416c0,0-2.452,1.769-1.93,1.056c0.527-0.701,0.174-4.915,0-4.208
        c-0.174,0.695-8.788-3.694-8.788-3.694l-2.993,2.635v-3.339l-4.556-2.807l0.531-3.692l-2.124-1.758c0,0-0.342,0.525-0.518,0.176
        c-0.174-0.348-1.407-7.377-1.407-7.377l-6.682-5.449l-8.073-0.353l-7.383-4.051l-1.581-3.683c0,0-4.219-1.925-4.219-2.454
        c0-0.525-1.217-0.172-1.579-0.355c-0.342-0.17-0.165-1.923-0.165-1.923l-1.947-1.592l-0.695-0.472l-1.718-0.52l-1.052-1.469
        c0,0,3.822-1.707,3.427-1.57c-0.386,0.123-8.558,1.308-8.558,1.308l-0.789,1.577l-3.824-1.971l-6.455-0.399
        c0,0-4.62-1.839-4.488-2.364c0.139-0.529-1.447-2.505-1.447-2.505s-1.054,2.505-1.319,2.768c-0.26,0.262-3.55,3.03-3.55,3.03
        l0.254,4.223l-2.236-2.382l1.586-2.241v-3.158c0-0.404,1.976-1.319,1.976-1.319l-0.792-1.707c0,0-2.366,0.657-2.366,1.054
        c0,0.393-3.162,2.236-3.162,2.236l-3.826,1.447h-1.711c0,0-1.709,2.761-2.117,2.9c-0.39,0.135-0.249,2.642-0.249,2.642
        s-4.227,4.732-4.492,4.208c-0.262-0.525-4.732-4.208-4.732-4.208l-5.282,0.648l-3.026,1.588l-3.692-2.505l-2.895-4.479l0.271-5.268
        l1.577-5.806l0.657-3.813l-3.954-2.907c0,0-8.036,0.659-8.036,0.265c0-0.388-4.355,0.139-4.219-0.265
        c0.126-0.39,1.581-2.893,1.581-3.295c0-0.397,1.059-3.423,1.059-3.423l1.713-3.423l2.238-6.576l1.312-2.252l-6.583-0.393
        l-3.956,1.579l-2.238,6.594l-11.203,3.028l-2.765-2.106c0,0-0.265,1.186-0.123,0.527c0.123-0.657-3.429-5.277-3.429-5.277
        l-1.716-6.448c0,0,4.485-13.317,4.344-13.046c-0.13,0.258,0.141-4.885,0.141-4.885l14.096-9.218l5.396,0.789l1.317,1.317
        l3.301-0.536l3.292-3.288l4.205,0.551l4.08-0.787l2.51,2.77l3.681-1.447l1.978,2.113l1.195,1.308v2.247l-0.922,2.104l0.922,4.746
        l2.633,3.694l1.711,0.655l2.108-5.795l-0.399-5.403l-0.92-4.36v-3.16l5.407-6.574l6.975-5.015l5.535-3.162l4.876-5.268l-0.262-5.008
        l2.119-0.39l2.088-4.477l2.11,0.247l4.093-5.134l6.843-2.364l4.225-0.787l1.319-1.449l-1.581-1.317l3.29-4.885l10.413-4.084
        l6.329-1.844l-5.147,3.297l1.054,2.499l3.822-1.052l2.77-1.709L1.478-11.4c0,0,1.722-2.904,1.451-2.245
        c-0.254,0.657,3.694-0.659,3.694-0.659L5.835-15.89l0.262-2.106l-2.104,0.792l-3.178,3.425l-5.132-0.251l-2.366-3.566l2.238-3.03
        c0,0,2.236-4.481,2.106-4.21c-0.135,0.256-3.553-1.059-3.553-1.059l-5.143,1.837c-0.525,0-5.401,2.902-5.273,2.51
        c0.135-0.395-2.505,1.449-2.505,1.449l6.717-5.394l2.772-0.401l3.165-2.904H8.996l5.14-1.056l6.847-3.685l0.536,0.662l-2.902,2.761
        l-3.559,3.692l-3.434,3.683l-1.709,2.245l5.403,0.262c0,0,4.212,0.106,4.613,0c0.527-0.132,0.657,1.841,0.657,1.841l2.236-1.579
        l1.193,3.03l3.956-3.03l-1.193-3.427l1.061-3.169l-4.613,0.141v-1.716c0,0-1.709-1.976-1.844-1.716
        c-0.137,0.267,2.633-2.234,2.499-1.971c-0.13,0.265-1.191-1.314-1.191-1.314l3.173-3.965l-1.579-4.472l-0.536-2.234l-4.086-1.978
        l-1.447-1.98l-1.85-1.447l1.455-3.429l-0.662-2.501c0,0-1.18-8.173-1.312-7.912c-0.139,0.267-5.544,4.485-5.544,4.485l-5.524,2.772
        l-2.909-2.505l0.273-3.303l2.503-2.368L0.556-65.3l-0.262-1.054c0,0-3.687-3.689-3.947-3.429c-0.265,0.273-1.186,1.195-1.186,1.195
        l-8.7-0.803l-3.028,5.275l-0.657,2.765c0,0-4.766,4.768-5.348,5.136c0.348-0.101,2.578,2.117,2.578,2.117l-1.983,4.735l-7.509,4.349
        l-3.683,0.534c0,0-2.245,8.175-2.113,8.697c0.13,0.531-3.028,1.971-3.028,1.971l-2.241,1.583l-0.926-2.893
        c0,0-1.01-2.214-1.411-2.774c0.589,0.243,2.728,0.527,2.728,0.527l0.401-1.85l-2.113,0.137l0.926-3.032l1.976-3.288l-6.856-0.529
        l-1.566-1.848l-3.436-0.529l-0.271-1.453l-2.371-1.444l-2.902-1.317l-3.156,0.395l-0.135-2.761l0.805-2.635l-3.156-0.525
        c0,0,5.535-5.672,5.403-5.407c-0.141,0.262,15.54-7.782,15.54-7.782l1.85-1.967l3.026-0.271l6.587-3.023l5.008-3.425l0.527,0.265
        l-3.813,3.555l-1.054,1.31l-3.032,1.453l2.77,0.393l-0.404,1.588l3.037-0.529l3.026-2.505l2.382,0.798l1.056,1.175l3.288-0.132
        l-0.132-2.501l-5.132-3.685l-1.2-1.184l-0.52-1.321l2.232,0.273l1.859,1.579l1.971-1.985l3.952-0.518l3.952-2.779l-0.256-1.709
        l3.026-2.895l-1.983-2.104l5.275-0.132l4.602,0.132c0,0,2.247-1.052,2.644-0.395s3.819,3.156,3.819,3.156l-1.317,1.186L0.569-86.77
        l-1.317,2.626l3.963,0.534l3.023-3.16l3.29-0.267l0.529,3.156c0,0-3.685,2.113-4.21,2.243c-0.527,0.141-2.772,1.184-2.772,1.184
        l-0.132,2.379l-3.557,0.39L-4.3-78.337l-1.709,0.128l-2.772,2.236l2.241,1.976c0,0,3.297-1.317,3.822-1.709
        c0.525-0.393,2.238-1.189,2.631-0.525c0.395,0.657,2.629,2.501,2.629,2.501L4.4-70.163l1.711,0.523l5.264,1.711
        c0,0,3.694,0.924,3.694,1.182c0,0.265-0.386-2.236-0.386-2.236l-2.785-3.297c0,0-0.121-0.922,0.789-0.666
        c0.933,0.262,3.176,2.234,3.176,2.234c0.388,0.132,3.028,1.727,3.028,1.727l1.052-2.902l2.368-1.451l-0.915-1.713l-1.321-1.444
        l-1.447-1.713l0.128-1.974c0,0,0.397-0.273,0.792-0.527c0.393-0.26,1.579-1.184,1.846-0.666c0.258,0.527,2.904,3.956,2.904,3.956
        l2.492,0.523l1.193-1.971c0,0,3.288-0.399,3.288-0.265c0,0.132,0.265-1.579,0.265-1.579L34.57-81.5l-4.344-3.833l-2.368-1.189
        l-1.852,0.529l-1.7-1.976l1.839-1.707l0.796-2.377l-2.11-2.106l-3.295-0.657l-0.798-1.72c0,0-2.761-0.393-3.158-0.135
        c-0.399,0.273-2.373-2.366-2.373-2.366l-1.713-2.236c-0.267-0.135-1.186-1.063-1.711-0.924c-0.536,0.132-6.062,0.262-6.062,0.262
        l-1.317,0.397l-1.709-1.323l-6.858,1.718l-3.553,2.768c0,0-0.26-1.583,0-1.976c0.256-0.395,2.761-1.844,3.158-2.106
        c0.395-0.262-3.028-0.401-3.028-0.401s-6.329,2.113-6.591,2.507c-0.262,0.393-5.14,4.212-5.14,4.212l0.141,3.165l4.474,0.664
        l1.711,0.386l-1.186,1.061l-0.92,1.974l-2.895,1.581l-3.566,2.631l-3.03,1.184l-0.523-2.104l2.633-1.581
        c0,0-0.527-3.288-0.792-3.028c-0.262,0.265-3.026-0.13-3.16,0.265c-0.128,0.397,0.135-2.499,0.135-2.499l-0.135-2.772l-0.657-2.115
        c0,0,2.243-1.841,2.631-1.971c0.397-0.132,4.613-0.397,4.613-0.397l6.722-3.819l-5.537-0.258c0,0-5.132,0.126-5.401,0.659
        c-0.265,0.527-3.683,4.08-3.683,4.08l-2.11,1.581l-6.984,4.355l-0.267,3.026L-40-90.596l-2.104-0.397l-5.264,2.106v2.898
        l-9.635,0.534c0,0-4.605-0.666-4.605-1.317c0-0.666-1.711-1.98-2.236-1.98c-0.536,0-6.464,1.844-6.464,1.844l-0.262,1.841
        l-6.852-0.388c0,0-5.663,1.045-5.531,0.525c0.132-0.525-3.034-0.267-3.034-0.267l4.743-2.108l-3.288-1.581l-5.939-0.92l-4.212-1.317
        l-4.735,0.659l-0.527-1.974l-4.225,1.707l-1.186-2.768l-2.895,1.321c0,0-10.803,2.238-11.333,2.368
        c-0.523,0.135-3.156-1.054-3.156-1.054l-3.306,1.579l-6.316,0.395l-2.51-1.841l-5.136-1.052l-5.667,0.262l-10.548-1.718
        c0,0-6.056-0.922-5.661-1.061c0.395-0.132-3.288-1.054-3.288-1.054s0.148-0.439,0.262-0.695c-1.292,0.547-11.595,2.274-11.595,2.274
        l-13.831,4.488l-9.094,1.841c0,0,0.262,2.371,0.39,2.763c0.135,0.404,0.924,3.032,0.924,3.032l-2.501,0.527h-2.646l1.33-1.841
        l-13.454,3.687l0.276,1.449l-0.928,1.713l4.216,0.395l3.561,0.395c0,0,1.976-1.182,1.976-0.787c0,0.395-1.054,3.418-1.054,3.418
        l-4.082,0.265c-0.262-0.395-2.375,0.139-2.375,0.139s-2.772,1.7-2.902,1.317c-0.132-0.395-5.526,0.922-5.526,0.922l-6.201,3.559
        l-2.366,3.555l-0.262,2.631l4.611-0.783l-2.64,3.561l3.032-0.139c0,0,3.561,0,3.824,0.536c0.267,0.527,1.841,0.265,1.841,0.527
        c0,0.267-31.358,12.385-31.625,11.992c-0.223-0.404-4.829,2.104-4.829,2.104s6.053-1.052,6.457-1.052
        c0.393,0,9.348-2.113,9.348-2.113l4.219-1.186c0,0,9.094-2.633,9.216-3.03c0.135-0.399,6.464-3.692,6.858-3.692
        c0.397,0,2.503-0.92,2.64-0.39c0.126,0.525,9.09-2.366,9.09-2.366s3.158-2.247,2.902-2.642c-0.273-0.395-2.113-1.449-1.586-1.577
        c0.525-0.135,5.262-0.798,5.262-0.798s7.121-2.893,6.991-2.503c-0.132,0.399-7.246,5.147-7.246,5.147l10.148-1.98l4.089-1.718
        c0,0,3.423-1.579,3.16-1.182c-0.265,0.395,3.954,1.577,3.954,1.971c0,0.395,8.823,1.718,8.823,1.718l2.637,3.954l-0.534,5.134
        l-0.26,6.464l4.741-0.529l-1.18,4.214l0.271,6.988c0,0,0.254,2.501,0.254,2.895c0,0.395-3.689-0.787-3.689-0.787
        s-0.529,3.028-0.135,3.42c0.41,0.395,4.752,4.743,4.752,4.743l-1.451,1.848l-3.301,8.168l-7.773,8.955l-1.312,4.887l-3.824,4.21
        l0.659,3.032c0,0-1.054,2.113-0.781,2.373c0.254,0.26,1.839,14.625,1.839,14.625l5.537,3.423l1.444,2.637l0.792,10.803l2.366,4.874
        l-2.631,1.846l3.028,4.208l1.189,0.139l2.379,2.761l-0.928,3.694l2.499,1.974l2.377,3.692l0.397,1.841l2.243-2.236l-2.243-4.611
        c0,0-1.581-3.434-1.449-4.214c0.132-0.794-2.104-6.724-2.104-6.724s-2.119-4.483-1.848-4.876c0.256-0.399-1.59-3.026-1.59-3.026
        l0.928-5.401l3.822,0.789c0,0,0.659,4.997,0.659,5.533c0,0.525,0.924,3.689,0.924,3.689l5.004,6.973l-0.785,3.564l9.613,11.461
        l-0.132,4.616l-1.451,2.234l0.789,3.169l8.042,5.928l1.314-0.26l2.368,2.373l8.693,4.351l4.351,1.056l5.147-1.586l3.29,1.586
        l5.008,5.795l5.138,1.312l5.264,1.852h2.516l0.659,3.023c0,0,2.371,3.034,2.898,3.429c0.523,0.395,0.132,3.824,0.132,3.824
        l2.236,1.178l2.637,2.772l1.711,1.588l1.85,2.104l1.182-0.789l2.373,0.655l3.418,3.169l2.241-1.325l-0.644-2.499l2.091-2.106h1.85
        l1.98,1.577l-0.135,1.846l2.371,3.819l0.135,10.673l-2.108,3.431l-2.904,1.976l-0.123,3.153l-3.037,1.184l-1.184,4.219l-1.848,3.692
        l0.395,3.158l2.64,2.373l-2.377,2.516l-1.707,2.496l1.568,4.984c0,0,0.787,2.51,0.787,2.243c0-0.262,2.516,1.722,2.516,1.722
        l4.609,9.211l4.472,6.468c0,0,6.508,13.115,6.64,13.218c1.965,1.444,16.303,11.772,16.303,11.772l2.446,12.823l0.714,27.052
        l2.104,7.74l-0.887,15.637l-0.695,3.158c0,0,2.807,4.918,2.807,5.628c0,0.701,0.525,6.843,0.525,6.843l1.93,6.677l2.282-0.172
        l-1.405-3.864l1.762,0.176l1.219,6.144l0.174,2.454l-1.394-1.228l-1.235,1.228l-0.88,1.059l1.758,1.588l-0.875,2.443l-0.348,3.171
        l2.459,0.353l1.755,1.403l-1.755,2.986c0,0,10.885,19.15,20.024,21.428c9.138,2.293,11.772,2.99,11.772,2.99l3.872-2.11l1.215-1.577
        l-8.073-2.809l-6.148-6.686l-1.235-3.506l1.932-1.4l-0.346-2.642c0,0,0-1.93,0.692-2.454c0.71-0.525,2.113-3.162,2.113-3.162
        l-2.113-1.056l-3.509-3.509l0.351-4.051l2.113-1.219c0,0,0.17-2.291-0.176-2.816c-0.359-0.52,0.527-3.165,1.054-3.337
        c0.531-0.181,1.923-2.291,1.923-2.291h-2.448l-1.403-0.52l-1.764-2.803v-2.117l2.986,0.878l2.82-0.529l1.579-2.282
        c0,0-0.527-1.403-0.701-1.927c-0.176-0.525,0.351-2.814,0.875-2.99c0.525-0.165,3.685,0.176,3.685,0.176l5.976-1.577
        c0,0,2.287-4.047,2.113-4.748c-0.176-0.701-0.176-2.986-0.176-2.986s0-1.577-1.403-1.764c-1.414-0.17-1.414-0.688-1.764-2.11
        c-0.357-1.4-1.414-2.981-1.414-2.981l-1.751,0.353l1.586-1.577l3.513,2.626l5.266,0.889l4.044-4.047l2.814-6.854l1.226-5.096H20.2
        l2.807-5.094l1.061-4.741l-0.878-5.804l1.228-2.097l9.132-6.15l6.858-2.287l2.293-1.764c0,0,3.502-4.737,3.502-5.264
        c0-0.527,1.409-7.383,1.409-7.383s1.577-8.071,1.396-8.596c-0.17-0.536,0.357-7.56,0-7.736c-0.353-0.172,0.181-2.113,0.181-2.113
        l6.677-9.482l3.162-7.211c0,0,2.293-3.685,1.938-4.386c-0.331-0.772-2.249-6.748-2.249-6.748L58.624,164.995z M128.089-92.18
        c0,0,1.061-5.277,0.271-5.804c-0.801-0.525,3.162-3.687,3.162-3.687s5.789-2.637,6.053-3.42c0.262-0.796-1.579-0.542-1.579-0.542
        l0.523-3.947l3.696-1.317c0,0-2.104-3.167-2.64-4.75c-0.52-1.566,6.329-2.364,6.329-2.364l12.122-5.533l-14.488,1.579l-0.536-1.839
        l-15.282-3.429l-30.558,1.061l-3.418,1.844H81.188l-14.751,1.319c0,0-13.966,1.839-14.757,2.364
        c-0.785,0.531,1.583,1.321,1.583,1.321l-0.262,1.846l-17.137,2.113l-1.047,1.844c0,0,1.841,1.841,2.104,2.106
        c0.258,0.262,7.379,1.841,7.379,1.841l8.435,1.054c0,0,4.746,2.11,5.526,2.893c0.798,0.789,0.542,3.173,0.273,4.49
        c-0.273,1.319-1.054,1.579-2.106,3.16c-1.059,1.586,2.106,0.789,2.106,0.789l3.692,1.841c0,0-1.054,0-2.642,0.273
        c-1.588,0.262-3.692,0.781-3.692,0.781l-0.262,2.909l5.279-1.052l-0.542,1.839l-3.683,0.789l-3.661,4.474l-0.267,8.433l0.787,7.114
        l2.108,5.8l3.429,0.527l3.954,2.373l5.277-0.269l5.262-7.112l5.531-5.271l1.583-2.898l2.642-1.579l5.789-1.314l7.383-1.588
        c0,0,6.843-4.481,7.643-5.008c0.783-0.525,19.757-6.314,19.757-6.314l4.19,0.26H128.089z M133.382-72.95l7.379-2.368l1.572-2.895
        l-2.889-2.368l-13.448,1.579l-3.952-2.377l-4.737,2.64c0,0,2.368,1.054,3.158,1.579c0.789,0.527,2.371-0.525,2.371-0.525v2.371
        c0,0,4.216,2.368,3.683,3.165c-0.529,0.787,6.858-0.798,6.858-0.798H133.382z M146.371-37.027l-1.493,0.975l-0.441,1.674
        l1.319,0.787l2.11,0.439l2.188-0.527l1.857-1.054l0.52-0.525l3.076-0.19l0.351-1.303l0.71-1.323v-3.778l1.667-0.968l-0.536-2.452
        l-2.629-0.613l-2.106-0.353l-1.403,0.437l-0.805,1.14c0,0-1.301,1.407-1.043,1.136c0.271-0.254,0.964-0.254,0.798,0.183
        c-0.183,0.437-0.893,0.875-0.893,0.875h-1.036l-0.898-0.527l-1.31,0.174l-0.443,0.792l0.538,1.231l-0.889,0.882l1.054,0.88
        l1.05,0.254l-0.163,1.235l-1.213,0.52L146.371-37.027z M156.823-47.385c0.617,0.256,0.875,0.615,0.789,0.873
        c-0.077,0.273,1.319,0.445,1.319,0.445l1.147-0.26l-0.789,1.228c0,0,0.172,0.792,0.432,1.145c0.271,0.351,1.151,0,1.151,0
        s2.11-0.353,2.375-0.265c0.256,0.084-0.095,0.878-0.095,0.878l0.798,1.226c0,0,0.43,1.76,0.518,2.282
        c0.095,0.536-0.703,0.348-0.703,0.348s-1.654,0.262-2.022,0.185c-0.351-0.088-1.045,0.606-1.658,1.305
        c-0.62,0.717,0.088,0.445,0.088,0.445h1.305c0,0,0.104,0.873,0.185,1.237c0.079,0.351-1.056,0.695-1.4,0.606
        c-0.351-0.084-1.936,0.708-1.936,0.708l0.082,1.319l1.938,0.174l1.936,0.265l0.351,0.613c0,0-1.244,0.265-1.588,0
        c-0.351-0.262-1.405,1.405-1.405,1.405l-0.964,1.054l-2.029,1.579l1.14,0.529l0.706-0.882l1.766,0.088l1.919-0.262
        c0,0,1.153-1.405,1.418-1.405c0.256,0,2.984-0.084,2.984-0.084s2.196-0.441,2.459-0.265c0.262,0.176,2.022,0.531,2.296,0.615
        c0.258,0.086,3.683-0.966,3.683-0.966s0.699-1.14,0.873-1.491c0.183-0.351-0.959-0.701-1.222-0.966
        c-0.262-0.265,0.873-0.613,1.405-0.875c0.523-0.262,0.699-1.233,0.966-1.667c0.254-0.434-0.355-1.325-0.443-1.581
        c-0.084-0.271-1.317-0.19-1.665-0.271c-0.351-0.09-1.844,0.082-1.844,0.082l0.079-1.755c0,0-4.128-5.619-4.04-5.881
        c0.088-0.256-0.966-1.932-1.405-2.013c-0.439-0.088-0.968-0.452-1.495-1.153c-0.523-0.697,0.703-1.581,0.703-1.581
        s1.489-1.579,1.667-1.927c0.176-0.353-0.181-1.405-0.439-1.493c-0.267-0.086-3.332,0.088-3.332,0.088s-0.875-0.701-0.794-0.964
        c0.09-0.276,0.968-0.357,1.235-0.357c0.249,0,1.841-3.067,2.192-3.156c0.348-0.095-0.267-0.878-0.267-0.878l-1.224,0.512
        l-1.142,1.68c0,0-1.063,0.262-1.493,0c-0.434-0.265-1.321,0-1.672-0.088c-0.351-0.099-1.153,1.054-1.153,1.054
        s-1.217,1.317-1.572,1.403c-0.351,0.088-1.581,1.493-1.493,1.579c0.095,0.088,0.174,1.235,0.174,1.235s-0.262,0.432-0.701,0.52
        c-0.437,0.086,0.348,1.579,0.348,1.579l1.063,0.534c0,0-0.624,0.609-0.972,0.527c-0.353-0.097-1.147,0.882-0.529,1.14
        L156.823-47.385z M570.018-66.442c0-0.073-0.04-0.073-0.115-0.029c0.088,0.057,0.11,0.077,0.11,0.029H570.018z M462.16,88.594
        c0.176-0.262,2.631-1.493,2.717-2.115c0.093-0.602,1.846,5.72,1.846,5.72l1.239,4.388c0,0,0.957,3.158,1.31,3.775
        c0.353,0.62,0.871,4.657,0.871,5.01c0,0.348,1.156,2.712,0.624,2.981c-0.538,0.262-1.405,0.086-1.237,0.441
        c0.185,0.346,0.611,2.282,0.611,2.646c0,0.346-0.258,2.71-0.426,3.151c-0.185,0.441-0.262,1.583-0.262,2.102
        c0,0.531,0.335,1.506,0.335,1.76c0,0.269,0.271,0.706,0.271,0.706s0.357,0.181,0.525-0.265c0.181-0.441,1.495-0.613,1.678-0.441
        c0.17,0.181,2.188,2.543,2.368,3.255c0.172,0.697,2.368,4.13,2.626,4.479c0.267,0.353,1.414,1.497,0.697,2.459
        c-0.697,0.966-0.697,1.14-0.602,1.665c0.086,0.525,0.353,2.454,1.224,3.522c0.889,1.047,2.721,3.067,2.721,3.067
        s2.291,1.592,2.644,2.031c0.344,0.434,2.893,0.697,3.165,1.749c0.251,1.052,0.959,2.115,0.959,2.115s2.016,0.609,2.016,0.88
        c0-0.218-0.013-3.286-0.256-3.705c-0.258-0.428-2.364-4.737-2.638-4.997c-0.256-0.267-0.695-0.878-0.432-2.009
        c0.262-1.156-0.179-4.144-0.179-4.144l-4.128-4.922c0,0-3.603-3.515-3.689-3.334c-0.086,0.172-2.816-1.056-2.71-2.11
        c0.071-1.052-0.284-3.683-1.072-4.3c-0.781-0.611-1.484-1.586-2.099-1.934c-0.611-0.359-0.172-3.694,0-4.133
        c0.17-0.439,1.577-4.298,1.495-4.556c-0.097-0.262,0.348-3.864,0.348-3.864s1.138-1.508,1.4-0.977c0.271,0.525,1.495,0,1.142,1.581
        c-0.348,1.592-0.168,2.558-0.168,2.558l3.153-0.622l2.203,2.289l1.586,2.102l2.018,1.233c0,0,0.525,2.375,0.787,2.54
        c0.269,0.183,1.583-0.525,1.583-0.525l2.02,1.416c0,0-1.147,2.102-0.873,2.637c0.258,0.525,0.514,2.364,0.514,2.364l1.941-1.583
        l2.465-1.844l1.228-1.758l0.439-1.314l3.506-1.502l3.341-3.072l-0.082-6.503l-1.056-4.036l-2.986-4.219l-5.804-5.793l-2.274-2.809
        c0,0-1.586-2.02-1.504-2.543c0.09-0.536,0.432-3.339,0.432-3.339l1.592-1.497l3.078-3.074c0,0,2.106-1.405,2.459-1.056
        c0.348,0.353,3.158,0.265,3.248,0.525c0.082,0.265,0.45,0.181,0.258,0.701c-0.176,0.525,0.086,2.902,0.348,3.167
        c0.271,0.265,0.889,0.52,1.151,0.613c0.247,0.084,1.138-0.267,1.228-0.792c0.09-0.523-0.09-2.371,0-2.812
        c0.09-0.437,0.262-0.437,0.529-0.525c0.262-0.088,1.572,0,1.572,0l1.414-1.405l2.454,0.878l2.635-2.289c0,0,1.409-0.256,1.586-0.084
        c0.172,0.183,2.466-1.753,2.466-1.753l2.368-0.529l2.102-0.88c0,0,0.878-2.022,0.878-1.762c0,0.267,5.101-5.087,5.101-5.087
        l1.667-4.13l2.016-5.884l1.228-7.299l0.093-2.104c0,0-1.936,1.577-2.194,1.672c-0.267,0.082-1.844-0.348-1.844-0.348l1.224-2.201
        c0,0,0.706-1.579,0.353-1.667c-0.353-0.09-2.11-0.613-2.11-0.613s0.756-1.729,0.869-1.841c-0.161,0-3.056-2.99-3.056-2.99
        s-3.87-5.533-4.047-5.098c-0.176,0.441-3.158-2.104-3.431-2.104c-0.251,0-0.432,0.086-0.604-0.437
        c-0.176-0.529,2.635-4.219,2.721-4.492c0.086-0.254,2.54-2.984,2.99-2.893c0.428,0.088,1.925,0.174,1.925,0.174
        s-0.359-1.753-0.617-1.841c-0.256-0.086-6.228-0.613-6.228-0.613s-2.368,1.405-2.459,1.755c-0.101,0.351-2.016,0.179-2.016,0.179
        l-0.269-2.022l-2.384-1.14l-2.715-0.966l0.093-1.846c0,0,1.661-0.611,1.927-0.8c0.262-0.176,2.368-1.219,2.54-2.106
        c0.176-0.88,1.586-2.282,1.766-2.547c0.172-0.262,1.31-1.228,1.568-1.052c0.271,0.174,1.949,1.405,1.762,1.493
        c-0.165,0.086-1.308,1.936-1.056,2.454c0.273,0.536,1.502,2.119,1.33,2.377c-0.172,0.269-0.706,1.235-0.706,1.235l1.319-0.176
        c0,0,1.667-1.317,1.577-1.491c-0.086-0.19,1.319-1.672,1.581-1.672s3.169-0.624,3.244-0.362c0.095,0.267,2.995,0.966,2.995,0.966
        l0.529,5.279c0,0,7.028,1.667,7.028,2.108c0,0.437-0.794,1.136-0.794,1.136s-0.088,1.407,0.265,1.588
        c0.348,0.168,1.489,1.136,1.758,1.493c0.273,0.351,0.794,2.728,0.794,2.728s-0.961,2.104-0.794,2.368
        c0.172,0.267,1.932,1.844,1.932,1.844l5.01-1.932c0,0,2.717-2.106,2.717-2.368c0-0.269-2.893-7.295-2.893-7.295l-6.682-4.578
        l-2.889-2.368l4.036-3.947l-0.353-3.423c0,0,0.878-3.35,1.054-3.35c0.185,0,2.638-1.751,2.638-1.751l2.807,1.943l4.219-2.642
        l2.373-8.512l0.086-11.077l-3.778-6.761c0,0-1.753-4.128-2.027-4.128c-0.262,0-2.803-3.961-2.803-3.961l-5.886-2.629l-2.554-0.088
        l-1.575,2.631l-1.663-2.018l-2.285-4.036l0.258,2.457c0,0,0.353,1.579,0.247,1.93c-0.066,0.351-1.747-2.196-1.747-2.196
        s-2.809-0.523-2.984-0.523c-0.17,0-1.581-0.798-1.581-0.798s4.144-4.818,3.784-4.646c-0.348,0.172,0.701-6.148,0.701-6.148
        s1.491-2.993,1.577-2.816c0.09,0.179,5.789-0.613,5.789-0.613s10.455-0.17,10.369,0c-0.086,0.183,5.101-0.344,5.101-0.344
        s0.168,1.493,0.622,1.669c0.428,0.172,4.642-0.095,4.642-0.095l3.076-0.699l1.486-0.181c0,0-1.839-1.841-2.106-1.841
        c-0.262,0-2.016-0.796-2.188-0.884c-0.183-0.088,1.314-3.418,1.224-3.947c-0.082-0.529-0.258-2.371,0.439-2.194
        c0.701,0.179,5.456,0.179,5.456,0.179s1.923,1.837,1.923,2.366c0,0.525,3.076,2.368,3.076,2.368s1.674-1.844,1.844-2.192
        c0.148-0.28,1.036-1.27,1.376-1.433c-0.423-0.346-1.804-2.166-1.804-2.166s1.486-1.674,2.274-0.796
        c0.801,0.88,2.549,4.655,2.549,4.655s-1.586,3.95-1.586,4.307c0,0.344-0.611,3.956-0.611,4.223c0,0.26-1.76,1.839-1.76,1.839
        s-0.869,0-0.869,0.439c0,0.437,1.217,2.805,1.217,2.805s0.454,2.728,0.701,2.893c0.269,0.192,9.057,7.822,9.057,7.822l5.705,5.632
        l3.698,3.067l1.047-0.26c0,0,0.884-4.3,0.531-4.135c-0.355,0.183-1.762-1.31-1.579-1.568c0.17-0.28,0.52-1.511,0.955-1.42
        c0.448,0.095,1.762,0.348,1.762,0.348l-2.635-3.334l0.873-1.839l2.029,0.613l-2.726-2.895l-1.405-2.816c0,0,1.493,0.348,1.592,0.609
        c0.077,0.28,1.665-1.127,1.136-1.222c-0.531-0.097-3.692-1.235-3.692-1.5c0-0.26-1.839-0.699-1.941-1.054
        c-0.079-0.348,0.355-1.753,0.101-1.753c-0.262,0-2.986-1.228-2.986-1.228l-1.769,0.254l-0.966-1.921l0.525-1.493
        c0,0-1.683-2.39-1.835-2.543c0.135,0.121,3.753-1.261,4.097-1.409c-0.018,0.057,1.711-0.143,1.863,0.516
        c0.183,0.708,0.966,1.411,0.966,1.411l1.855-1.755c0,0,1.314-1.147,1.841-0.887c0.527,0.262,3.074,0.8,3.434,1.145
        c0.313,0.322,1.912,0.776,2.159,1.065c-0.024-0.368,0.031-1.508,0.031-1.508l0.075-0.964l2.476-3.334c0,0,0.955-1.403,1.844-1.588
        c0.878-0.168,2.717-1.749,3.067-1.482c0.353,0.258,3.266,0.176,3.617,0.966c0.344,0.787,1.925-0.265,1.925-0.265
        s-1.502-1.841-1.581-1.672c-0.082,0.174-4.924-1.938-5.185-1.841c-0.267,0.079-3.506-1.936-3.506-1.936s-1.678-0.615-1.758-0.615
        c-0.086,0,1.308-0.703,1.833-0.88c0.531-0.172,1.764-1.841,1.764-1.841s-0.611-1.14-0.968-1.493
        c-0.355-0.348,1.934-0.086,2.721,0.265c0.787,0.351,4.752,0.525,4.657,0.789c-0.097,0.26,2.635,0.26,2.545,0.966
        c-0.09,0.703,0.966,0.873,1.319,1.228c0.353,0.353,3.689,0.878,3.87,0.966c0.161,0.086,3.5-0.262,3.5,0.26
        c0,0.529,1.059-0.084,1.059-0.084s-0.525-2.545-1.14-2.371c-0.622,0.174-1.769-0.703-0.97-0.875c0.794-0.174,2.287-1.054,1.85-1.231
        c-0.445-0.172-1.145-1.054-2.199-1.497c-1.05-0.439-5.268-1.396-5.707-1.231c-0.434,0.183-7.03-1.409-7.456-1.409
        c-0.45,0-2.732-0.606-2.732-0.606l-22.487-6.062c0,0-13.966-1.491-13.884-1.762c0.095-0.256-8.078-0.964-8.078-0.964l4.838,4.042
        l-4.838-0.699c0,0-5.967-0.966-6.144-1.231c-0.181-0.26-16.698-0.351-16.698-0.351l-2.454-2.646c0,0-7.91-1.305-8.173-1.394
        c-0.262-0.097-10.104,0-10.104,0l-8.241-1.231c0,0-5.542-2.377-6.772-2.11c-1.228,0.265-13.35-0.789-14.056-1.145
        c-0.697-0.353-5.522,0.353-5.522,0.353l3.932,2.988l-6.488-0.181l-6.501-0.09l-2.465-1.226l0.101,3.603c0,0-1.85,0.342-1.85-0.095
        c0-0.439-5.714-2.454-5.714-2.454s-4.75-4.212-4.829-3.947c-0.09,0.26-7.714-1.495-7.714-1.495l-4.759-0.873
        c0,0-1.405,0.611-1.233,0.964c0.176,0.351,2.02,1.579,1.758,1.841c-0.262,0.26-3.153-0.262-3.153-0.262l-7.469-0.262l-1.328-1.405
        l-9.838,0.088c0,0-3.687-2.902-3.78-2.734c-0.079,0.176-2.807,0.631-2.807,0.631l-2.11,2.278l-5.967,0.441l6.422-3.429l2.282-1.665
        c0.165-0.45-1.597-3.078-1.936-2.73c-0.346,0.355-5.365-1.228-5.628-1.228c-0.262,0-7.818-0.176-7.818-0.176
        c-0.534-0.086-2.898,0-2.898,0s-0.878-2.454-1.319-2.368c-0.434,0.088-6.153-0.088-6.153-0.088s-5.09,1.054-5.281,1.579
        c-0.157,0.531,0.979,1.054,0.979,1.054s-2.721,2.02-2.988,1.844c-0.258-0.176-8.173-0.176-8.173-0.176s-10.978,2.368-10.978,2.104
        c0-0.225-3.286,1.178-4.051,1.515c0.646,0.567,2.951,1.879,2.646,2.188c-0.348,0.348-7.734,0.701-7.996,0.172
        c-0.236-0.483-3.156,0.631-3.619,0.701c0.531,0.221,3.989,2.924,4.23,3.337c0.262,0.437,0.898,1.054,1.758,0.701
        c0.878-0.351,1.667-0.701,1.848-0.351c0.176,0.351,0,1.14,0,1.14s-2.201,0.441-2.454,0.441c-0.251,0-2.902-1.495-3.167-1.581
        c-0.258-0.088-3.773-0.878-4.216-0.878c-0.45,0-2.379,0.262-2.379,0.262s-1.491,1.319-1.142,1.495
        c0.364,0.174,1.239,1.841,1.506,1.672c0.258-0.183,1.844-0.884,1.925-0.09c0.09,0.781-1.839,1.407-1.839,1.407
        s-2.646-1.063-2.732-1.319c-0.086-0.273-1.319-1.76-1.319-2.551s-1.577-3.599-2.016-3.162c-0.434,0.441-2.016,0.615-2.016,0.615
        l1.934,1.755c0,0,1.663,1.4,1.224,1.493c-0.434,0.088-1.667,0.787-1.749,1.054c-0.09,0.262-1.056,1.751,0.082,1.751
        c1.142,0,2.988,1.764,2.988,1.764s0.086,2.375,0.258,2.726c0.176,0.351,2.893,2.192,2.893,2.192s1.683-1.054,1.93-1.314
        c0.278-0.265,2.562-0.701,3.087-0.176c0.527,0.525-1.059,1.841-1.493,1.581c-0.443-0.267-1.405-0.529-1.844-0.355
        c-0.448,0.174-0.448,0.174-0.448,0.174s-0.611,1.319,0,1.581c0.62,0.267,1.42,1.145,1.328,1.581
        c-0.095,0.437-1.758,3.427-1.758,3.427l-2.465,0.525c-0.878-0.174-2.278-0.789-2.278-0.789l2.633-2.016l0.353-2.728
        c0,0,0.09-0.174-0.611-0.789c-0.717-0.611-3.169-2.805-3.169-2.805s-1.491-2.463-1.491-2.726c0-0.276-0.701-1.588-0.701-1.588
        s-1.672-1.14-2.024-1.219c-0.344-0.09-0.344-1.061-0.077-1.586c0.258-0.529-0.267-2.895-0.357-2.547
        c-0.101,0.353-3.081-0.086-3.436-0.174c-0.353-0.086-1.138-1.054-1.138-1.054s-0.434-1.486-1.149-0.875
        c-0.695,0.613-1.923,0.875-1.923,0.875l-1.228,3.246l0.348,1.319l-2.459,1.674c0,0,2.075,1.784,2.267,1.921
        c-0.15-0.073,0.11,1.771,0.192,2.207c0.079,0.439,3.773,1.407,3.773,1.407s1.934,0.787,2.106,1.577
        c0.181,0.789-0.529,1.758-0.529,1.758l-3.769-1.758l-8.353-2.631c0,0-8.071-0.525-7.901-0.787c0.183-0.262-3.078-2.113-3.078-2.113
        l-1.846,0.964c0,0,1.753,1.237,2.027,1.314c0.262,0.097,2.898,1.063,2.898,1.063s0.794,0.439,0.966,1.142
        c0.183,0.699-1.491,1.577-1.491,1.577s-1.138-1.228-1.138-1.489c0-0.265-0.271-1.319-0.62-1.145
        c-0.353,0.176-3.601,1.846-3.601,1.846s-3.689,0.086-4.133,0.437c-0.439,0.351-2.809,2.024-2.986,1.581
        c-0.181-0.439,0.348-2.282,0.269-2.633c-0.093-0.351-3.694,0.617-3.694,0.617s-4.649,1.489-4.832,1.925
        c-0.172,0.445-2.278,0.88-2.64,0.968c-0.348,0.088-0.783,0.088-0.783,0.088s-1.839,1.147-1.495,1.753
        c0.353,0.617-2.547,0.964-2.547,0.964s-1.839-1.138-1.925-1.394c-0.084-0.24,1.996-1.638,2.194-1.758
        c-0.269,0.174-2.194-2.285-2.461-2.373c-0.232-0.071-5.006,0.053-5.857,0.018c0.556,0.203,2.256,1.848,2.256,2.091
        c0,0.265,0.267,2.814,0.267,2.814s1.394,0.884,1.663,0.781c0.262-0.079-0.269,1.5-0.269,1.5l-2.357-0.262
        c0,0-0.979-1.414-1.769-0.615c-0.792,0.798-3.42,2.816-3.592,2.554c-0.181-0.265-1.672,0.262-1.583,0.789
        c0.09,0.529,1.23,1.665,1.23,1.665s-1.665,1.405-1.502,0.882c0.183-0.534-4.558-1.758-4.913-1.669
        c-0.364,0.088-2.379,0.703-2.379,0.703l0.873,1.491c0,0,2.642,0.174,2.988,0.701c0.364,0.525-0.604,1.579-0.882,1.579
        c-0.247,0-6.4-2.898-6.4-2.898s-2.024-2.104-1.416-2.717c0.631-0.615,1.151-1.579,0-1.579c-1.136,0-2.364-0.884-2.443-1.235
        c-0.093-0.351,6.927,0.71,6.927,0.71l4.051,0.432c0,0-0.525,0.534,1.056,0c1.575-0.527,4.212-1.85,4.565-1.925
        c0.353-0.104,0.783-1.769,0.783-1.769l-0.525-1.491l-15.099-3.599c0,0-5.015-1.493-5.101-1.755
        c-0.086-0.262-4.481-0.708-4.481-0.708l-2.113,0.271l1.769-2.201c0,0-6.863-2.027-7.03-1.764c-0.185,0.262-2.99,1.597-2.99,1.597
        l-5.268-0.884l-6.77,1.579l-6.854,1.674l-9.919,4.212l3.689,0.351l-1.59,2.719l-4.393,3.262l-2.45,4.033l-0.353,2.196l-2.368,2.543
        c0,0-1.667-0.875-2.018-1.222c-0.348-0.359-6.155,1.658-6.155,1.658l-3.509,3.341c0,0-0.878,1.674-1.054,2.113
        c-0.183,0.443,0.262,5.098,0.262,5.098s2.108,0,1.491,0.613c-0.617,0.611-0.529,3.429-0.529,3.429l2.463,1.658
        c0,0,3.246,1.063,3.698,0.97c0.421-0.086,2.013-1.14,2.282-1.317c0.245-0.172,2.19-2.104,2.803-2.024
        c0.613,0.097,2.192-1.672,2.375-1.045c0.172,0.615,0.527,2.809,0.873,3.337c0.351,0.527,1.579,1.493,2.104,2.717
        c0.523,1.233,1.244,2.468,1.059,2.719c-0.183,0.273-1.409,1.493-1.409,1.493s-2.626,0.351-2.984,0.714
        c-0.348,0.346-0.787,0.52-1.052,0.346c-0.271-0.176,0.875-1.411,1.14-1.749c0.267-0.359-0.613-1.766-0.966-1.68
        c-0.357,0.093-0.699-0.789-0.357-1.052c0.357-0.265,0.269-1.932,0.269-1.932s-0.527-0.267-0.787-0.174
        c-0.265,0.088-3.339,1.314-3.339,1.314s-1.667,1.758-1.755,2.106c-0.095,0.362-0.798,2.201-0.348,3.513
        c0.437,1.325,1.489,3.434,1.489,3.434s1.131,0.785,0.701,1.14c-0.432,0.348-1.323,1.667-1.323,1.667l-2.097,0.086
        c0,0-3.778,0.448-4.135,0.615c-0.346,0.181-4.031,1.314-3.866,1.672c0.185,0.351-0.794,4.133-0.794,4.133
        c-0.17,0.088-3.861,2.721-4.298,2.721c-0.439,0-3.16,0.699-3.16,0.699s-1.231,3.251-1.314,3.072
        c-0.088-0.179-4.139,1.932-4.139,1.932s-3.07-0.88-3.158-1.235c-0.088-0.348-1.145-1.138-1.228-0.873
        c-0.093,0.267,1.05,2.999,1.05,3.526c0,0.514,0.179,1.57-0.174,1.226c-0.353-0.359-2.108-0.875-2.457-1.054
        c-0.359-0.172-3.341-0.093-3.341-0.093h-1.231c0,0-1.497,1.323-1.586,1.056c-0.082-0.267-0.17,1.147-0.17,1.147l0.873,0.873
        l3.171,1.317l2.984,1.846l1.142,2.807l1.314,2.635c0,0-0.88,5.445-1.043,5.716c-0.194,0.258-2.031,1.495-2.031,1.495l-5.714-0.097
        c0,0-2.812-0.611-3.074-0.699c-0.262-0.093-4.219,0.525-4.296,0.174c-0.088-0.355-1.323-0.267-1.323-0.267l-0.622-0.699h-1.579
        l-1.317,1.489l-1.932,0.097v1.572c0,0,0.789,3.61,0.701,3.348c-0.088-0.271-0.348,4.21-0.348,4.21s-1.899,3.817-2.091,4.108
        c0.042,0.115-0.104,2.569-0.104,2.569l1.145,1.848l0.174,2.19c0,0-0.88,2.018-0.527,1.844c0.355-0.179,3.169,0.086,3.246-0.262
        c0.088-0.348,1.762-1.14,2.018-0.529c0.26,0.613,1.235,0,1.508,1.063c0.245,1.052,1.219,2.543,1.314,2.803
        c0.086,0.273,0.787,0.527,0.787,0.527l0.262,0.71l-0.534,0.441l-2.183,4.911l-4.843,3.429l-2.893,1.839l-0.792,2.203l-1.226,1.405
        l-0.353,2.721c0,0,0.353,3.42,0.17,3.601c-0.17,0.174-6.585,6.236-6.585,6.236l-3.513,0.789l-1.941,3.341
        c0,0-2.633,2.452-2.803,2.902c-0.183,0.432-1.497,2.108-1.497,2.108s0.088,3.506,0,2.984c-0.09-0.527-3.773,2.893-3.773,2.893
        s-0.701,4.042-0.875,4.223c-0.174,0.168-1.93,3.246-2.201,3.158c-0.262-0.09-0.525,2.106-0.525,2.459c0,0.348,0.873,1.4,0.873,1.4
        s1.239,2.382,1.323,2.117c0.084-0.271,0.084,0.794,0.084,0.794l-1.224,1.222c0,0,1.319,2.027,1.319,2.289v5.438l-1.411,2.993
        l-0.701,3.868l-2.115,1.665l0.088,1.056l1.848,1.489l0.271,1.665l-0.536,1.85v1.852l1.325,3.074c0,0,1.317,1.052,1.579,0.787
        c0.262-0.265,2.889,1.667,3.246,2.278c0.353,0.615,3.597,4.481,3.597,4.662c0,0.172,0.529,1.052,0.529,1.052l1.579,5.359
        c0,0,7.643,6.32,7.82,6.06c0.176-0.256,8.17,5.705,8.17,5.705s6.422-3.153,6.336-2.887c-0.095,0.258,5.436-0.267,5.436-0.267
        l3.343,0.525l2.45,1.142l8.969-4.122l1.758-1.332l6.933-0.254l3.343,1.303c0,0,2.194,3.262,2.194,3.789
        c0,0.527,1.319,2.893,1.497,2.54c0.17-0.342,7.818-0.695,8.087-0.611c0.254,0.086,3.595,3.345,3.595,3.345l-0.174,3.079
        l-0.531,5.438l-1.056,2.637l-1.043,2.375l-0.262,1.669c0,0,7.893,11.595,7.893,11.681c0,0.086,2.022,4.825,2.022,4.825l2.382,6.069
        l1.407,3.418l-1.407,1.932l2.285,5.897l-0.794,5.789l-3.427,7.474l-1.491,5.531l0.439,7.379l4.115,8.521l4.311,9.752l0.439,10.722
        l3.434,6.404l2.465,5.178l2.368,5.63l1.224,1.669c0,0,0.183,2.812-0.095,2.812c-0.258,0-1.57,0.095-1.217,0.611
        c0.348,0.525,2.364,4.042,2.364,4.042l0.086,1.586l2.807,1.572l2.476-1.138c0,0,2.454-0.434,2.721-0.348
        c0.258,0.086,3.678-1.147,3.678-1.147l5.273,0.792l3.692-1.93l4.042-0.262c0,0,6.938-6.768,6.938-6.591s6.4-8.252,6.4-8.252
        l3.266-2.818l1.837-5.531l-0.26-3.592c0,0,0.617-1.859,1.226-2.207c0.622-0.348,6.587-3.861,6.587-3.861l1.242-5.802l-1.151-5.714
        c0,0-0.882-2.185-0.882-2.54c0-0.346,0.615-1.938,0.615-1.938l5.804-5.18c0,0,1.314-1.669,1.93-2.282
        c0.617-0.613,6.053-2.981,6.053-2.981l3.698-3.595l0.615-13.271c0,0-1.319-4.931-1.405-5.361c-0.086-0.45-2.633-8.783-2.633-9.141
        c0-0.346-0.878-5.447-0.977-5.892c-0.071-0.423,2.016-6.314,2.016-6.314l2.909-5.718l11.864-13.613l6.682-5.35l10.098-16.524
        l3.253-7.646l0.695-7.721l-2.102-0.353c0,0-1.059,1.228-1.321,1.4c-0.265,0.181-6.325,0.534-6.325,0.534l-7.381,2.188l-3.601,1.319
        l-3.513-3.683l0.525-2.633l-4.737-5.63l-6.68-6.664c0,0-3.35-2.554-3.169-2.809c0.181-0.271-1.85-6.419-1.85-6.243
        s-3.334-3.07-3.334-3.07l-0.086-5.892l-3.601-5.877l-3.945-7.211c0,0-3.345-8.261-3.698-8.7c-0.344-0.437-1.663-2.629-1.228-2.543
        c0.439,0.09,3.601-0.351,3.601-0.351s5.881,6.944,5.881,7.295c0,0.351,3.522,6.23,3.522,6.23s2.631,3.694,2.631,3.423
        c0-0.249,0.615,3.427,0.525,3.698c-0.086,0.265,1.581,4.307,1.581,4.307l5.01,4.483l1.052,3.244l4.567,5.006l0.884,3.167
        l-3.081-2.82c0,0-0.966,1.586-0.615,1.857c0.348,0.256,3.425,3.509,3.425,3.509l1.506,4.474l1.142,4.223l1.663,1.405l4.924-0.964
        l0.871-1.941h4.834l2.106-1.577l2.626-0.353c0,0,2.024-2.022,2.199-2.11c0.181-0.088,7.998-3.506,7.998-3.506
        s0.17-2.558,0.525-2.558c0.353,0,8.177-2.459,8.177-2.459l0.787-2.984l2.803-0.176l0.792-2.016l2.723-1.667l0.342-4.395l2.027,0.609
        l0.62-1.495l-0.701-0.955l3.076-4.479l0.086-1.59l-2.988-2.721l-1.4-1.491c0,0-4.748-0.534-4.929-0.884
        c-0.172-0.353-2.016-4.571-2.016-4.571c0-1.31,0.086-3.689-0.181-3.509c-0.254,0.174-1.749,1.841-1.749,1.841l-5.436,5.01
        l-4.754,1.228c0,0-1.575-0.439-1.667-0.699c-0.086-0.265-0.262-4.309-0.262-4.309s-2.029-2.371-2.108-2.719
        c-0.086-0.353-1.586,3.079-1.586,3.079s-2.285-3.079-2.027-3.176c0.262-0.082-1.052-3.07-1.052-3.07l-4.56-5.264l-0.262-2.728
        c0,0,2.196-2.377,2.545-2.465c0.348-0.086,3.511-0.523,3.866,0.624c0.353,1.131,2.988,5.01,2.988,5.535s4.033,4.036,4.479,3.947
        c0.432-0.086,2.009,0.789,2.545,1.142c0.525,0.351,1.572,0.966,2.016,1.411c0.439,0.43,1.581,0.174,1.581,0.174l2.9-0.443
        c0,0,2.368-2.285,2.463-1.844c0.077,0.448,2.803,0.622,2.454,1.228c-0.353,0.617,0.097,2.379,0.348,2.904
        c0.273,0.531,12.122,2.375,12.122,2.375l5.456,0.701c0,0,5.784-0.531,6.137-0.531c0.348,0,4.051,0.359,4.399,0.258
        c0.344-0.077,5.617,5.714,5.617,5.714l4.92,2.47l1.136-0.093l-2.796,1.233c0,0,0.953,2.196,0.953,2.457
        c0,0.265,4.924,3.78,4.924,3.78s1.753-1.149,2.016-1.149c0.269,0,1.497-0.437,1.588-1.052c0.086-0.613-0.269-2.366,0.172-2.543
        c0.448-0.176,1.05-0.708,1.153,0.088c0.077,0.785,1.149,8.34,0.966,8.422c-0.192,0.104,1.491,5.716,1.491,5.978
        c0,0.265,2.196,7.121,2.278,7.383c0.09,0.26,3.687,7.99,3.95,8.254c0.258,0.265,3.78,9.394,3.78,9.394s2.024,3.78,1.934,4.399
        c-0.086,0.615,0.706,3.599,1.235,3.952c0.525,0.351,2.891,1.231,2.891,1.231s1.314-1.149,1.411-1.493
        c0.079-0.348,1.052-1.93,1.394-2.454c0.355-0.536,1.952-0.701,2.031-0.355c0.082,0.355,1.936,1.231,1.936,1.231l-0.192,4.3
        c0,0,0.362,2.803,0.62,3.875c0.278,1.052,2.465,1.93,2.465,1.93l2.635-2.371l1.138-4.051l-2.626-3.945c0,0-2.016-2.194-2.282-2.465
        c-0.267-0.254-1.949-0.516-1.949-0.516s0.192,0.88,0.362,1.224c0.183,0.353-0.362,0.445-0.362,0.445l-2.016-0.787l0.353-2.304
        c0,0,1.511-0.258,1.769-0.258c0.256,0-0.106-3.511-0.106-3.511s0.545-6.23,0.721-6.406c0.176-0.183-0.267-6.325-0.97-6.585
        c-0.695-0.265,0-2.282,0.355-2.373c0.348-0.093,3.773-1.317,3.773-1.317l1.925-3.778c0,0,3.436-2.377,3.698-2.554
        c0.258-0.176,4.208-4.384,4.208-4.92c0-0.518,0.45-1.837,1.497-2.024c1.056-0.165,2.995-1.572,2.995-1.572v-2.902
        c0,0,0.348-1.405,1.138-1.753c0.783-0.353,2.807-0.62,2.807-0.62s0.445,1.145,0.176,1.317c-0.267,0.181,4.477-1.317,4.477-1.317
        s2.106,0,2.459-0.084c0.359-0.093,1.411-1.665,1.411-1.665s-0.45-1.414,0.161-1.065c0.626,0.364,2.121,1.941,1.949,2.205
        c-0.187,0.251,0.871,2.013,0.615,2.715c-0.271,0.701,4.038,5.456,4.038,5.456s2.099-0.973,1.93-0.269
        c-0.183,0.701-0.611,2.904-0.611,2.904s1.319,0.873,1.839,0.964c0.529,0.086,2.022,2.984,2.022,2.984s-0.353,2.629-0.353,2.981
        s0.19,2.904,0.086,3.345c-0.086,0.437,3.601,1.239,3.601,1.239s2.977-2.39,3.153-2.66L462.16,88.594z M201.722-41.936l2.904-2.461
        l0.62-2.375c0,0,2.717,0.443,2.798,0.794c0.086,0.346,0.712-0.794,1.403-0.174c0.71,0.613,1.59,0.518,1.68,1.05
        c0.077,0.529,0.611,1.145,0.697,0.792c0.086-0.353,0.086-1.493,0.086-1.493s-0.783-0.437-1.228-0.71
        c-0.443-0.26-0.351-1.052,0.09-1.305c0.432-0.262,1.663-0.979,2.018-0.71c0.353,0.256,1.936-0.351,1.936-0.351
        s0.262-0.536,0.434-0.787c0.183-0.273,1.061-2.64,1.061-2.64s-0.626-0.262-0.798-1.056c-0.176-0.785,0.97-3.072,1.239-3.156
        c0.251-0.09,3.692-2.115,3.692-2.115s1.314-1.409,0.787-1.841c-0.531-0.445-4.481-2.375-4.481-2.814
        c0-0.439-0.439-2.723-0.183-3.597c0.267-0.875,1.852-2.551,2.113-2.904c0.267-0.342,2.199-2.717,2.551-2.637
        c0.353,0.095,1.667-0.176,2.011-0.344c0.359-0.183,3.425-1.586,2.9-1.672c-0.525-0.088,0.179-1.667-0.09-1.581
        c-0.262,0.086,0.269-2.018,0.884-2.192c0.611-0.174,1.663-0.966,1.938-0.966c0.247,0,2.371,0.088,2.895,0.174
        c0.525,0.088,2.368-0.787,2.631,0c0.262,0.789,0.959,0.966,0.353,1.228c-0.615,0.265-2.02,1.495-2.9,2.28
        c-0.873,0.787-3.515,2.556-3.868,2.635c-0.344,0.093-0.536,0.262-1.233,0.708c-0.701,0.43-0.701-0.613-0.869,1.05
        c-0.183,1.672-0.439,3.513-0.095,4.135c0.353,0.613,0.611,1.579,0.262,2.02s-0.09,0.703,0,1.493c0.09,0.789,1.162,1.138,1.237,1.491
        c0.082,0.351,1.486,1.052,1.486,1.052c0.701-0.079,1.511-0.17,1.672,0.183c0.183,0.351,0.536,0.176,0.536,0.176l1.48-0.359
        c0,0,1.502-0.878,2.031-0.789c0.525,0.088,1.224-0.174,1.839,0c0.615,0.176,3.246-0.701,3.608-0.615
        c0.348,0.097,2.801-0.964,2.984-0.611c0.176,0.351,1.495,0.262,1.495,0.262l1.056,0.789c0,0.525-1.056,1.753-1.314,1.936
        c-0.267,0.172-1.142,0.884-1.669,0.701c-0.525-0.17-0.886,0.088-1.588-0.17c-0.703-0.269-2.022-0.626-2.377-0.626
        c-0.351,0-4.47,0.979-4.47,0.979l-2.102,0.609l-0.364,1.235l0.267,0.262l2.108,1.314c0,0.443,0.884,0.176,0.701,1.231
        c-0.172,1.052-0.262,1.491-0.525,2.016c-0.269,0.529-1.319,1.495-1.581,0.878c-0.262-0.613-1.575-1.755-1.93-2.018
        c-0.344-0.262-1.398-0.088-2.029-0.088c-0.611,0-1.844,0.88-1.844,1.846c0,0.964-0.611,2.205-0.353,3.156
        c0.267,0.979,1.414,2.21,0.889,2.82c-0.536,0.617-1.758,1.056-2.282,1.317c-0.525,0.265-1.764,1.142-2.199,1.317
        c-0.439,0.174-1.758,0.701-2.024,0.088c-0.258-0.617-0.787-1.581-0.787-1.581s-0.439-0.873-0.622-0.611
        c-0.157,0.254-1.138,0.353-1.138,0.353l-2.274,0.875c0,0-1.239,0.875-1.497,1.052c-0.271,0.174-1.586,0.174-2.113,0.437
        c-0.525,0.267-2.108,1.583-2.543,0.968c-0.445-0.611-0.699,0.439-1.242-0.527c-0.514-0.964-0.346-2.02-0.966-1.839
        c-0.606,0.176-2.022,0.525-2.188,0.875c-0.183,0.351-0.357,0.351-0.697,0.701c-0.353,0.348-2.904,0.613-2.904,0.613v-0.174
        L201.722-41.936z M274.495,23.11c-0.657,1.716-0.657,3.952-1.586,5.667c-0.926,1.705-1.321,2.626-1.976,3.694
        c-0.662,1.041-0.662,2.496-1.711,3.153c-1.052,0.664-2.631,1.583-3.555,0.926c-0.915-0.662-4.609-0.527-5.015-0.395
        c-0.39,0.132-4.865-0.132-5.396,0.783c-0.525,0.926-3.939,0.269-4.483,0c-0.525-0.26-6.977-2.9-7.502-3.026
        c-0.525-0.13-3.833-1.577-4.364-1.971c-0.525-0.399-3.813-0.8-3.941-1.193c-0.135-0.397,0.262-0.922-0.273-0.789
        c-0.516,0.121-4.344,1.317-4.869,1.702c-0.536,0.41-1.705,1.462-1.705,1.462s-1.594,1.579-1.462,2.763
        c0.141,1.186,1.586,2.108,1.061,2.765c-0.525,0.657-2.368,1.447-2.368,1.447s-1.989-1.841-2.637-2.104
        c-0.659-0.265-6.845-1.184-6.845-1.184l-2.505-2.898c0,0-3.952-2.637-4.349-2.77c-0.399-0.13-4.746,0-5.412-0.525
        c-0.662-0.536-2.768-3.297-3.817-3.162c-1.056,0.13-0.657-1.581-0.262-1.844c0.393-0.262,1.579-2.503,1.449-2.898
        c-0.137-0.399,0.657-2.631-0.657-3.288c-1.317-0.675-0.399-2.913-0.399-2.913s1.321-0.262,0.794-0.262
        c-0.527,0-2.503,0.132-3.034-0.525c-0.518-0.659-0.666-0.92-1.178-0.659c-0.538,0.267-3.833,0.792-4.223,0.659
        c-0.399-0.13-3.555,0.262-4.082,0.262c-0.525,0,0.132,0.135-0.525,0c-0.668-0.132-3.306,1.061-3.434,1.579
        c-0.121,0.527-2.759-0.121-3.158,0c-0.401,0.132-4.219,0.132-4.219,0.132l-6.329,1.054c0,0-4.214,2.121-4.344,2.779
        c-0.132,0.659-1.451,1.713-1.844,1.969c-0.39,0.267-2.761,0-2.906-0.393c-0.124-0.395-4.346,0.137-4.346,0.137
        s-1.709-0.928-2.236-0.529c-0.525,0.395-0.525-1.718-0.525-1.718l0.657-1.568l2.368-1.586l5.674-1.063l2.768-1.837l1.705-0.659
        l1.05-2.763c0,0,1.978-0.395,1.846-0.796c-0.13-0.395-0.648-2.241-0.648-2.241l3.813-5.925l5.401-2.637l0.924-1.846
        c0,0-0.518-2.368-0.13-2.77c0.393-0.397,3.952-1.189,3.952-1.189l4.483,1.451c0,0,2.368-1.577,2.893-1.841
        c0.525-0.267,3.034-1.711,3.034-1.711s0.256-1.184,0.785-1.054c0.527,0.13,2.768-0.395,3.037,0.659
        c0.262,1.054,2.238,4.351,2.238,4.351l3.028,3.165l2.904,2.241l3.559,1.312c0,0,2.104,1.846,2.496,1.978
        c0.395,0.128,2.368,2.375,2.368,2.375l1.052,1.837c0,0-0.655,1.455-1.182,2.117c-0.525,0.651-2.106,2.371-2.503,2.229
        c-0.397-0.121-3.434-0.648-3.434-0.648l-3.29,0.393c0,0-0.518,0.792,0.401,1.449c0.922,0.657,1.974,0.529,2.891,1.054
        c0.937,0.525,3.306,1.586,3.306,1.586s1.586,0.256,1.586,0.648c0,0.397,0.52-1.054,0.388-1.974c-0.13-0.92-0.267-2.102,0.657-2.368
        c0.928-0.262,2.371,0,2.371-0.399c0-0.393,0.404-0.926,0.404-0.926l1.184-1.438l-0.132-0.92l1.193-0.937
        c0,0-0.657-0.774-1.193-1.442c-0.52-0.662-1.052-1.056-0.67-1.716c0.404-0.655,1.716-1.581,2.388-1.052
        c0.655,0.525,2.626,0.787,2.494,1.451c-0.126,0.653,0,1.572,0.269,1.054c0.254-0.531,0.132-2.64,0.132-2.64s-1.056-1.444-1.98-1.577
        c-0.913-0.137-3.303-1.319-3.956-1.581c-0.655-0.265-1.837-0.92-1.837-0.92s0.52-1.449-0.258-1.317
        c-0.798,0.13-3.167-0.271-3.167-0.659c0-0.404-2.375-2.252-2.496-2.637c-0.132-0.404-2.247-3.299-2.247-3.299
        s-1.193-1.184-1.319-1.579c-0.137-0.397-0.262-1.056-0.527-2.106c-0.271-1.054,2.631-3.689,2.501-3.297
        c-0.135,0.388,0.662,0.922,1.195,2.106c0.518,1.191,2.629,3.165,2.893,3.954c0.26,0.787,3.167,3.034,3.815,3.29
        c0.67,0.26,1.052,1.059,2.375,1.583c1.323,0.529,1.195,0.783,2.904,1.579c1.705,0.792,1.974,1.063,2.227,1.449
        c0.273,0.401,1.319,0.271,1.722,0.928c0.393,0.655,0.92,0.789,0.92,1.447c0,0.655,0.536,0.655,0.258,1.974
        c-0.258,1.317-0.651,1.711-0.516,1.974c0.132,0.269,2.505,5.147,3.429,5.147c0.92,0,3.683,1.054,3.288,2.629
        c-0.393,1.579,1.709,3.689,1.709,3.689s1.762,0.112,2.979,0.315c0.051-0.92-0.143-2.395,0.856-2.953
        c1.173-0.659,2.889-1.323,2.622-1.974c-0.269-0.657-0.531-1.848-1.581-2.633c-1.041-0.787-2.108-1.197-2.371-2.501
        c-0.258-1.321-0.659-3.041,0.525-2.51c1.184,0.523,2.241,3.039,2.779,1.314c0.518-1.709,1.833-2.898,2.752-2.501
        c0.933,0.395,2.646,1.052,2.514,1.579c-0.135,0.527,1.184,4.75,1.184,4.75s0.525,0.399,0.787,2.371
        c0.262,1.971,1.974,2.501,1.716,3.16c-0.267,0.653-1.061,1.047,1.056,1.317c2.097,0.265,4.084,0.655,4.084,1.182
        c0,0.529,1.711,0.803,1.976,1.191c0.258,0.397,1.839,1.184,2.106,0.397c0.262-0.783,0.792-2.377,1.186-2.113
        c0.395,0.273,3.687,0.273,3.954,1.332c0.273,1.039,2.507,1.039,2.507,1.319c0,0.254,1.976-0.659,1.976-0.659
        s2.763-2.113,3.555-1.718c0.787,0.395,3.021-1.458,2.759,0.256c-0.309,1.713,1.411,3.299,0.75,5.008H274.495z M287.66-0.08
        c-0.388,0.399-2.9,2.898-2.9,2.898l-5.008-0.662h-3.423l-2.898-1.05c0,0-1.98-0.657-2.373-1.056
        c-0.401-0.395-2.895-1.321-2.895-1.321l-5.275,1.189L258.8,1.106l-1.44,1.312l-4.878-1.182l-2.895-1.447l-1.59-1.718h1.451
        l-0.516-2.106l0.254-1.447l1.312-0.796l0.928-3.817l1.586-0.659l0.39-1.971c0,0,1.321-1.193,1.72-1.588
        c0.395-0.39,1.711-2.243,1.711-2.243l3.153,1.321c0,0,3.295,0.399,2.77,0.534c-0.536,0.128-2.113,1.978-2.113,1.978
        s1.186,0.648,1.731,1.052c0.514,0.395,1.707,1.047,1.44,1.844c-0.267,0.787,1.976,0.657,1.976,0.657l0.792-1.317l3.683-0.92
        l1.319-0.666l-2.11-0.648c0,0-1.844-0.666-1.577-1.063c0.267-0.399,1.976-3.032,1.976-3.032s4.351-1.312,4.741-1.312
        c0.386,0,3.039-0.527,3.039-0.527s-2.108,2.106-2.379,2.505c-0.273,0.399,0.137,1.707-0.525,2.241
        c-0.653,0.525-1.588,1.059-1.976,1.193c-0.404,0.121-0.139,1.444,0.258,1.579c0.406,0.135,1.718,0.657,1.718,0.657l5.8,3.026
        l3.555,3.555l2.776,2.252c-0.088-0.009,1.081,1.175,0.684,1.568L287.66-0.08z M321.135,17.306l-3.308,0.395
        c0,0-2.893-1.186-3.017-1.709c-0.143-0.525-0.798-1.711-1.195-1.449c-0.393,0.267-1.709,0.397-2.102,0.267
        c-0.393-0.135-1.855-1.319-1.855-1.846c0-0.523-0.401-1.707,0.262-2.241c0.666-0.525,1.982-1.442,1.716-1.848
        c-0.254-0.39-0.399-2.091-0.399-2.368c0-0.265,0-0.523,0.798-0.657c0.787-0.135,0.787-0.135,0.787-0.135s0.262-0.785-0.135-1.182
        c-0.393-0.397-2.772-2.11-3.034-2.503c-0.247-0.393-3.162-3.158-3.555-3.566c-0.39-0.386-2.106-1.57-2.106-1.57l-0.922-1.982
        l0.787-2.501l-2.364-0.527l-0.525-1.707v-0.399l2.494-2.893c0,0,1.72-0.92,2.11-0.668c0.395,0.273,1.312-0.787,1.464-1.182
        c0.117-0.404,2.618-2.115,3.154-2.377c0.523-0.26,1.442-1.447,1.976-0.787c0.52,0.655,3.813,1.716,3.813,1.716
        s1.195,0.26,1.052,0.781c-0.128,0.536-1.184,3.963-1.184,3.963s-2.364-0.659-2.626-0.527c-0.256,0.126-2.102,0.792-1.709,1.844
        c0.393,1.054-1.447,0.395-1.319,0.922c0.126,0.523,0.393,1.314,0.792,1.579c0.397,0.262,2.626,1.447,2.893,2.238
        c0.258,0.796,3.945,3.167,3.945,3.167s0.399,0.26,0.267,0.796c-0.124,0.525-0.395,3.29,0,3.29c0.395,0,1.312-0.135,1.312-0.135
        s1.197-2.499,1.594-2.234c0.393,0.26,1.976,1.444,2.371,2.366c0.386,0.922,1.184,1.839,0.787,2.104
        c-0.404,0.26-2.243,0.132-2.768,0.132c-0.518,0-1.451-0.659-1.714-0.397c-0.271,0.265-0.787,0.922-0.397,1.709
        c0.397,0.798,1.193,1.98,1.592,2.252c0.388,0.258,0.778,0.119,1.974,1.186c1.184,1.054,1.577,1.575,1.184,2.763
        c-0.397,1.184-0.135,2.241,0,2.631c0.13,0.395,0.393,1.317,0.662,1.711c0.256,0.397,0.256,0.92,0.256,0.92l-3.881,0.659
        L321.135,17.306z M273.59-88.04c-0.046-0.018-0.097-0.018-0.115-0.018c-0.044,0.018,0.022,0.018,0.11,0.018H273.59z M593.746-60.735
        c0.011-0.02-0.009-0.055-0.031-0.082c0,0.09,0,0.135,0.022,0.082H593.746z M356.154-105.193c0,0,0.055-0.013,0.161-0.064
        c-0.09-0.082-0.152-0.143-0.161-0.183C356.066-105.799,356.154-105.193,356.154-105.193z M318.82,189.073
        c0,0-2.818,3.171-2.986,3.705c-0.185,0.518-2.459,3.33-2.823,4.205c-0.353,0.878-3.153,2.807-3.153,2.807l-5.096,2.11
        c0,0-1.753,0.176-1.231,0.889c0,0-0.353,1.396-1.575,2.981c-1.235,1.577,0,3.683,0,3.683l0.695,3.513v3.343
        c0,0-1.056,3.689-1.581,3.861c-0.52,0.181-1.4,1.233-1.925,2.992c-0.534,1.753-0.353,2.984-0.353,2.984s0.353,2.635-0.181,3.167
        c-0.536,0.525,0.878,3.156,1.414,4.044c0.525,0.871,1.932,1.396,1.932,1.396s1.222,1.059,1.753,1.405
        c0.525,0.353,3.158-0.688,3.158-0.688s1.938-0.878,2.459-1.237c0.529-0.359,0.884-0.525,1.93-2.282
        c1.061-1.758,0.359-1.233,0.525-1.758c0.187-0.525,1.228-2.816,1.764-5.8c0.525-2.988,0.706-2.812,1.405-5.445
        c0.697-2.637,1.577-3.345,1.753-5.443c0.176-2.11,0.348-2.995,0.52-3.703c0.181-0.697,1.945-3.33,2.113-5.092
        c0.172-1.749,0.172-2.633-0.168-3.33c-0.348-0.712,2.108-0.187,2.452-1.239c0.359-1.056,0,0,0.181-0.518
        c0.179-0.536,0.359-3.868,0.359-5.798c0-1.932-1.934-4.931-2.128-5.447c-0.176-0.529-1.213,0.706-1.213,0.706L318.82,189.073z
        M494.312,163.603c0.536-1.405,0-1.581-0.346-2.282c-0.348-0.701,0.695-3.859,2.106-5.094c1.405-1.233-0.701-1.414-0.701-1.414
        l-2.108,0.353l-1.934-3.689c0,0-3.339-2.626-4.388-3.334c-1.056-0.697,1.57-2.11,1.57-2.11s-5.959-5.621-6.664-5.621
        c-0.701,0-4.223-2.807-4.748-2.99c-0.525-0.17-3.334-4.918-3.334-4.918l-11.952-5.97c0,0-1.577,1.411-1.577,2.106
        c0,0.703,2.11,1.054,2.11,1.054s0.697,0.525,1.4,0.88c0.701,0.353,2.807,2.106,2.986,3.343c0.17,1.224,0.529,1.93,1.758,2.977
        c1.237,1.056,3.334,1.592,3.334,1.592s0.889,2.981,1.592,3.334c0.697,0.353,1.228,1.927,1.57,2.812
        c0.355,0.878,3.698,6.322,3.509,8.254c-0.168,1.934,2.474,6.505,2.474,6.505s5.974,4.737,6.15,5.445
        c0.172,0.697,4.549,1.932,4.549,1.932s2.161-1.808,2.69-3.198L494.312,163.603z M535.065,127.592c0-0.701-1.934-2.278-2.465-2.986
        c-0.525-0.708-3.683-3.517-4.384-4.042c-0.697-0.525,0,0-1.052,1.941c-1.052,1.93-2.287,4.212-2.818,4.384
        c-0.529,0.176-4.384,2.633-5.445,3.861c-1.052,1.228-3.153,4.395-3.855,3.881c-0.701-0.536-3.703,2.267-3.703,2.267l-1.577,3.866
        l-4.922-1.047l0.348,1.586c0,0-1.572,2.448-1.22,2.986c0.353,0.527,0,2.463,0.525,3.506c0.52,1.063,1.052,1.762,1.93,2.463
        c0.878,0.701,1.052,2.986,0.525,4.743c-0.527,1.758,0.708,2.106,1.405,2.818c0.701,0.697,2.28,0.878,2.986,0.342
        c0.701-0.529,2.11-0.695,2.999-0.17c0.86,0.525,3.158,0.525,3.855,1.405c0.701,0.878,3.515,0.348,4.036,0.878
        c0.536,0.525,3.345-0.529,4.042-1.242c0.695-0.688,0-2.091,0-4.384c0-2.282,0.353-2.106,1.59-2.986
        c1.228-0.878,2.106-1.581,2.278-2.803c0.183-1.237,0.531-3.343,0.531-4.399s2.812-0.875,3.332-1.231
        c0.542-0.353-0.353-1.052-0.353-1.577c0-0.534-2.282-2.988-2.803-3.868c-0.525-0.884,0.873-5.275,1.747-5.976
        c0.926-0.728,2.492-3.528,2.492-4.234L535.065,127.592z M510.476,174.85c0.523,0.176,1.751,0.176,4.377,0.878
        c2.651,0.701,5.109,0.882,5.456,1.581c0.353,0.697,2.626,0,3.694-0.172c1.052-0.181,3.52-2.465,5.096-0.706
        c1.583,1.758,4.739,0.525,5.268,0.878c0.525,0.342,2.119-0.878,4.04-0.697c1.936,0.168,2.113,0.697,2.638,0.697
        c0.525,0,2.282,0.529,3.162,0.342c0.88-0.17,1.93-1.222,3.513-1.041c1.59,0.168,5.793-1.239,5.793-1.239s0,0.179-1.041,0.88
        c-1.061,0.701-4.576,3.332-4.576,3.332s-0.529-0.346-0.708,0.712c-0.17,1.052-1.222,3.165-0.17,2.276
        c1.059-0.867,4.748-4.033,5.628-4.735c0.869-0.701,1.222-1.059,2.102-1.586c0.878-0.525,2.807-1.056,2.807-1.056l1.237-0.878
        c0,0-1.059-0.697-1.59-0.525c-0.516,0.183-1.405-0.697-2.626-0.172c-1.235,0.525-4.567,1.052-4.567,1.052s-2.11,0.355-3.339-0.17
        s-2.642-1.407-3.164-0.708c-0.525,0.708-3.511,1.581-4.047,1.581c-0.518,0-2.454-0.176-3.859-0.523
        c-1.407-0.348-1.76-0.348-2.461-0.348s-0.701-0.525-2.633-0.708c-1.938-0.172-2.474-0.697-2.981-0.525
        c-0.545,0.183-1.405,0.353-2.106,0.708c-0.71,0.342-2.827,0.342-3.339-0.183c-0.536-0.525-5.811-1.577-5.811-1.577
        s-0.697-0.878,0.889-1.405c1.577-0.525,1.233-0.525,1.047-1.224c-0.172-0.714-2.814-0.714-3.506-0.525
        c-0.701,0.163-2.47,0.525-3.171-0.19c-0.697-0.688-2.807-2.465-3.504-1.407c-0.708,1.056-0.353,2.465-1.061,2.293
        c-0.697-0.172-5.451,0.348-5.451-0.172c0-0.525-1.228-1.938-1.758-2.121c-0.525-0.17-0.348-0.695-1.224-1.059
        c-0.882-0.333-2.635,0.181-2.635,0.181l-1.753,0.183l-2.113,2.454c0,0,4.92,0.534,5.447,1.233c0.525,0.706,3.162,2.807,3.162,2.807
        s3.506,0.878,4.391,1.052c0.926,0.265,4.962,0.419,5.491,0.617L510.476,174.85z M504.699,76.287
        c-0.545-0.348-1.938-0.348-1.938-0.348l-1.76,0.699l-0.878-0.351l-1.938,2.64c0,0,0.529,2.981,1.056,2.981c0.527,0,2.459,0,2.459,0
        l1.941-1.403l1.059-2.631C504.699,77.875,505.206,76.64,504.699,76.287z M533.146,69.261l1.056-2.113c0,0,0.529-2.108,0.699-2.633
        c0.179-0.536,0.873-2.113,0.359-2.99c-0.529-0.878-0.181-2.104-0.529-2.807c-0.355-0.697-0.529-1.755-0.529-1.755l-1.758,0.699
        c-0.701,0.701-1.753,3.864-1.753,3.864s-0.703,3.173-0.179,3.859c0.525,0.717,1.932,2.642,1.932,2.642l0.706,1.235L533.146,69.261z
        M555.265,122.145c1.581,0.531,2.11,0.187,1.93-0.534c-0.172-0.701-0.701-4.384-1.052-5.784c-0.353-1.405,2.106-2.465-0.525-4.567
        c-2.631-2.117-2.454-1.93-2.631-2.117c-0.179-0.176-0.179-1.93-0.179-1.93s0.525-1.753,0.179-2.278
        c-0.348-0.525-0.703-1.581-1.056-2.106c-0.353-0.529-0.353-0.701-1.409-0.701c-1.052,0-1.052-1.233-1.753-1.063
        c-0.697,0.176-2.459,1.579-1.233-0.516c1.233-2.121,0.534-2.47,0.534-2.823c0-0.348-0.889-0.873-1.762-1.047
        c-0.873-0.181-1.583-1.233-2.809-0.882c-1.228,0.362-1.753-0.52-2.459-0.52c-0.701,0-1.052-0.884-1.224-1.93
        c-0.181-1.056,0.172-3.167,0.172-3.689c0-0.534,1.052-2.113,1.052-2.113s0.353-0.71,0-1.934c-0.348-1.226-1.052-3.337-1.052-4.212
        c0-0.878-1.941-1.758-1.941-1.758l-2.287,0.878l-0.873,7.732c0,0-1.579,0.52-1.398,1.222c0.165,0.708,0.165,4.047,1.05,4.748
        c0.873,0.695,2.287,1.577,2.287,1.577c0.344,0.882-0.52,2.631-0.52,2.631s2.097,2.47,2.285,3.176
        c0.168,0.697,1.228,0.342,1.228,0.342s-0.525-4.741,0.52-3.868c1.056,0.882,3.864,0.717,4.036,1.762
        c0.183,1.056,2.113,2.106,2.454,3.167c0.353,1.054,2.642,1.407,2.474,2.276c-0.181,0.882-1.59,0.882-2.474,1.056
        c-0.869,0.176-3.683-1.925-3.683-1.925s-0.701-0.176-0.873,0.871c-0.172,1.056,0.348,3.687,1.052,4.565
        c0.697,0.884,1.405,0,1.76,0.525c0.353,0.536,0,1.764,0.529,2.47c0.518,0.701,1.925,0.873,2.459,0.52
        c0.525-0.344,2.282-1.228,2.282-1.228s-0.185-2.106-0.882-2.465c-0.701-0.348-1.758-1.405-1.224-1.923
        c0.52-0.531,1.572-1.583,2.106-1.411c0.516,0.176,1.76,2.461,1.577,2.986c-0.17,0.525,0,0.708,0.708,2.633
        c0.695,1.945,1.052,1.59,0.17,1.945c-0.878,0.342-1.753,1.405-2.287,1.753c-0.117,0.082-0.135,0.132-0.117,0.165
        c-0.128-0.042-0.465-0.104-1.283-0.165c-2.293-0.176-1.762-1.228-2.293-0.176c-0.518,1.052-1.052,1.93-1.052,1.93l-1.222,0.525
        c0,0-0.884,2.807-0.708,3.683l0.172,0.893c0,0,1.758-3.345,2.289-3.345c0.518,0,0.518,0.878,1.228,0.348
        c0.71-0.525,1.414-0.168,1.414-0.168s1.052-0.534,0.871,0.867c-0.161,1.405-0.161,1.581,0.348,3.004
        c0.54,1.396,1.945,2.102,2.47,2.626c0.525,0.525,1.222,0.878,1.577,1.228c0.353,0.348,0.525-1.581,0.353-2.986
        c-0.265-1.455-0.97-2.536,0.595-1.985L555.265,122.145z M542.982,143.403c1.945,1.056,3.158,1.588,4.739,2.113
        c1.59,0.525,3.158-1.056,3.515-0.699c0.348,0.346,1.936-1.235,1.936-1.235s1.222-1.758,1.052-2.278
        c-0.176-0.538-0.355-2.115-0.708-1.586c-0.342,0.52-3.687,2.459-4.384,2.629c-0.697,0.176-2.459-0.523-4.04-0.523
        c-1.583,0-5.447-1.233-5.983-0.706c-0.509,0.534-2.102,2.633-1.93,3.52c0.181,0.878,0,1.405,0,1.938
        c0,0.525-0.525,2.981-0.525,2.282l-2.457,6.488c0,0,1.927,4.929,1.76,5.809c-0.185,0.873-0.534,5.8,0,5.264
        c0.534-0.534,3.153-0.878,3.153-0.878s0.889-3.162,0.717-4.565c-0.181-1.405-1.769-5.8-0.364-5.447
        c1.416,0.353,2.818,2.106,2.818,2.106s-1.059,1.065-0.706,1.764c0.353,0.699,1.581,1.577,1.409,3.158
        c-0.176,1.581,0.525,2.287,0.525,1.753c0-0.525,1.76,0.353,1.936,0.706c0.15,0.315,1.813-1.156,2.071-1.142
        c0.02-0.525,0.282-2.679-0.146-3.248c-0.531-0.701-0.531-1.753-1.749-3.158c-1.239-1.42,0.348-1.76-0.884-3.354
        c-1.228-1.57-1.753-1.045-1.228-1.57c0.52-0.531,1.583-0.88,2.461-1.407c0.869-0.529,1.577-1.93,1.577-1.93
        c0.176-0.525,0.534-0.348-0.873-0.701c-1.405-0.353-2.642-0.71-3.517,0.353c-0.873,1.047-1.753,1.224-1.753,1.224s0,0-0.701,0.176
        s-0.529-1.052-1.056-1.228c-0.536-0.172-0.536-0.348-0.878-1.577c-0.355-1.233,0-3.167,0.534-3.526
        c0.507-0.331,1.72-1.566,3.661-0.507L542.982,143.403z M547.546,163.956c0.02-0.06,0-0.082-0.031-0.086
        c-0.022,0.11,0,0.176,0.022,0.088L547.546,163.956z M616.416,163.956c-0.168-1.056-0.353-2.282-0.864-3.158
        c-0.54-0.878-11.963-6.86-13.368-7.385s-8.766-2.809-8.766-2.809s-3.526,1.405-3.526,1.936c0,0.525-1.76,2.459-2.465,3.167
        c-0.695,0.697-0.523,1.4-1.575,1.228c-1.059-0.176-1.224,0-1.769-0.529c-0.509-0.525-1.045-2.293-1.747-2.812
        c-0.708-0.525-2.108-1.228-1.769-2.633c0.362-1.405,0.878-3.334-0.172-3.334c-1.05,0-2.626,0.708-2.981,0.168
        c-0.353-0.516-2.454-0.34-2.454-0.34l-4.386,1.228l-0.545,0.176c0,0,1.941,3.685,3.178,3.33c1.228-0.346,3.506,2.461,3.506,2.461
        s-0.697,1.586-0.348,2.11c0.348,0.525,1.758,3.165,1.758,3.165l2.807-0.176l2.809,1.228l7.56,2.459l2.117,2.45l1.228,5.284
        c0,0-3.171,2.102-2.99,2.981c0.172,0.88,4.042-0.17,4.042-0.17l3.158,1.577l3.855,1.93l4.404,0.17l2.626-2.981
        c0,0,3.859-3.334,3.859-2.631c0,0.703,3.522,2.106,4.051,3.689c0.536,1.581,3.692,4.399,3.692,4.399s4.384,1.405,4.915,1.581
        c0.52,0.163,1.76,0.348,2.995,0.697c1.228,0.351-1.237-3.169-1.237-3.169s-3.87-2.282-4.042-3.162
        c-0.172-0.88-3.334-3.506-3.158-4.386c0.172-0.878-1.416-1.93-0.703-1.93c0.703,0,3.509-0.348,3.16-0.886
        c-0.348-0.516-2.282-3.861-3.16-3.861c-0.904-0.154-3.55-0.154-3.727-1.191L616.416,163.956z M622.392,223.321
        c0,0-1.93-0.871-2.106-0.52c-0.174,0.353-0.884-3.339-0.884-3.339l0.353-1.93c0,0-5.277-6.684-5.438-6.148
        c-0.192,0.525-1.941-5.447-1.941-5.447l-0.523-6.499l-1.231-3.868l-3.158,0.353l-0.706-6.329l-1.769-5.972l-0.869-0.348l-1.76,4.036
        c0,0-0.878,5.628-1.233,7.56c-0.353,1.93-0.525,4.746-1.577,6.503c-1.056,1.758-3.517,5.965-3.517,5.965s-2.812,0-3.167-0.525
        c-0.348-0.525-3.506-2.11-3.506-2.11l-1.941-2.984l-3.151-2.454c0,0-2.126-2.642-2.293-2.465c-0.17,0.174,1.592-2.454,2.102-2.809
        c0.545-0.348,0.708-2.102,0.708-2.102l2.812-2.291c0,0,0.527-0.88,0-1.4c-0.529-0.531-0.529-1.411-1.228-1.592
        c-0.706-0.172-4.748,1.769-4.748,1.769l-3.334-1.588c0,0-2.466-1.233-2.981-2.11c-0.529-0.873-1.941-1.4-2.289-1.052
        c-0.353,0.353,0,2.106,0,2.106s0.721,1.548,0.975,2.031c-0.322-0.273-1.502,0.611-1.502,0.611l-3.339,0.342l-2.113,1.932
        l-1.581,2.992l-1.05,2.108c0,0,0.873,1.405,0.525,1.226c-0.353-0.174-5.099,1.233-5.099,1.233s-1.237-2.633-1.762-3.16
        c-0.525-0.531-2.102-1.407-2.807-1.407c-0.697,0-2.457,1.583-2.457,1.583l-0.695,3.685l-2.642-0.701l-2.289,3.864l-2.263,0.884
        l-1.246,2.631l-0.697-2.803l-2.635,2.454l-0.884,4.031c0,0-3.339,3.169-3.692,3.87c-0.348,0.697-7.738,3.345-7.738,3.345
        l-4.73,1.577c0,0-2.459,0.525-2.988,0.525c-0.525,0-5.101,3.343-5.101,3.343l-1.568,1.577l-0.529-1.405l-1.934,2.106v4.395
        l-1.934,2.629l1.056,4.038l-1.581,0.534l-1.405,1.061l1.583,3.162l0.525,5.784c0,0,0.875,1.764,0.703,2.823
        c-0.174,1.043-0.882,2.102-0.882,2.803s0.529,3.334,0.529,4.036c0,0.706-1.588,5.284-1.588,5.284l-1.923,3.158l-1.577,0.176
        c0,0,0.34,3.341,0.871,3.341c0.525,0,2.113,0.695,3.511,1.233c1.411,0.514,3.692-0.353,4.221-0.536
        c0.525-0.176,4.395-2.282,4.395-2.282s2.282-1.577,2.982-1.405c0.701,0.176,3.875-0.348,4.391,0
        c0.529,0.353,4.569,0.176,4.569,0.176l2.454-2.631l6.682-2.99l3.343-0.353l8.069-2.28l6.854,0.699c0,0,5.804,4.223,5.804,3.87
        c0-0.348,1.228,2.287,1.228,2.287l-0.348,3.33c0,0,1.927,1.581,2.099,1.056c0.181-0.529,2.117-2.635,2.646-3.162
        c0.514-0.525,2.11-1.224,3.341-2.102c1.222-0.882,1.57-1.409,1.57-1.409s-1.224,3.511-1.758,3.511c-0.525,0-1.588,1.052-2.113,1.758
        c-0.525,0.697-1.394,1.235-1.394,1.588c0,0.342,1.052,0.342,1.566,0c0.536-0.353,1.416-1.416,2.128-1.769
        c0.695-0.348,1.056-0.172,0.869,0.706c-0.172,0.878-0.172,1.749-0.869,2.102c-0.712,0.353-1.592,0.878-2.825,1.588
        c-1.217,0.706-2.099,0.17-2.631,0.706c-0.529,0.529,0.348,1.061,0.701,1.405c0.353,0.353,1.239,1.411,1.93,0.181
        c0.697-1.233,1.597-2.121,2.113-2.463c0.525-0.344,1.581-1.416,1.581-0.536c0,0.88,0.536,1.769,0.701,2.477
        c0.183,0.695-1.224,2.099-1.056,2.448c0.181,0.353,1.945,4.219,1.945,4.219s1.052,1.396,2.274,1.396c1.233,0,3.859,0.887,4.393,1.07
        c0.516,0.165,2.99,0,3.345-0.708c0.353-0.706,2.454-2.11,2.282-1.586c-0.181,0.529,0.172,1.586,0.697,2.11
        c0.525,0.525,1.405,1.941,1.405,1.941l6.503-5.105c0,0,4.915-1.056,5.09-0.525c0.181,0.525,3.334-3.506,3.334-3.506l10.012-12.296
        l3.881-2.642l2.805-4.042l3.859-7.037l2.11-7.886l1.583-5.976l-3.866-5.806l-1.566-4.94L622.392,223.321z M583.381,288.86
        c0,0-2.454-1.581-2.816-2.106v-0.529l-1.749,5.44l-1.577,5.806c0,0,3.153,0.353,3.506,0.525c0.353,0.17,5.628-2.984,5.809-3.689
        c0.172-0.706,3.687-6.501,3.687-6.501s-5.623,1.213-6.858,1.036L583.381,288.86z M678.603,278.672l-1.76-1.769
        c0,0,0.183-2.454-0.353-2.454c-0.518,0-1.405,0.176-1.405,0.176l0.884-6.157l-3.178-1.925l-0.692,9.487l-2.289,5.282l-4.556,1.758
        c0,0,1.93,1.925,2.631,1.925c0.697,0-0.529,2.108-0.529,2.108l-2.986,2.637c0,0-1.047-0.531-1.047-1.936
        c0-1.409-2.818,1.405-2.818,1.405l-1.93-1.233l-5.275,4.56l-7.2,3.698l-16.861,10.371l2.278,1.228c0,0,2.108,0.878,2.285,1.233
        c0.17,0.344,5.268-2.287,5.268-2.287l5.802-4.223l2.801-2.454c0,0,5.105-1.405,4.924-0.701c-0.168,0.701,1.581-3.337,1.581-3.337
        l4.92-2.635l2.99-2.981l2.454,0.69l3.515-1.228l5.974-3.861l1.052-3.169l1.941,0.187l3.678-2.642l2.459-4.216l-4.499,2.426
        L678.603,278.672z M-29.386-106.604c1.405,0.516,2.28,0.699,5.273,0.875c2.988,0.168,3.341-0.176,4.743,0.346
        c1.394,0.52,2.629,1.418,3.16,0.17c0.525-1.222,1.228-1.222,1.753-1.927c0.525-0.701,0-1.405,0.875-1.755
        c0.878-0.348,2.463,1.409,2.463,1.409s-1.936,1.231-1.059,1.398c0.875,0.183,3.337,0.706,4.574,0.875
        c1.231,0.183,0.176,0.527,2.285,0.721c2.104,0.165,2.984-0.194,5.615-0.194c2.637,0,4.227-1.219,5.103-0.875
        c0.875,0.348,3.859,0.348,4.735,0.179c0.878-0.179,2.997-2.104,2.113-2.104s-4.219-0.884-5.621-1.056
        c-1.403-0.174-5.806-0.351-6.847,0.174c-1.063,0.529-2.291,0.884-2.993,0.529c-0.701-0.351,2.993-3.158,5.447-2.809
        c2.463,0.351,6.148-0.348,7.377-0.174c1.228,0.174,4.225,0.701,4.225,0.701s0.695-0.351,0.869-0.875
        c0.179-0.527,0.355-1.054,0.355-1.054l1.76,1.579c0,0,11.588-4.739,12.122-5.623c0.527-0.886,7.895-3.165,8.964-2.981
        c1.052,0.168,8.248-2.99,9.487-2.465c1.213,0.527,7.721-1.572,7.721-1.572s4.75-1.059,5.804-1.059c1.056,0,1.579-1.226,0-1.052
        c-1.586,0.174-14.766,0.174-17.92,0c-3.171-0.174-10.896-0.007-12.124,0.174c-1.231,0.176-8.265,2.108-11.247,1.936
        c-2.99-0.179-12.647,1.222-13.172,1.047c-0.534-0.176-4.388-0.351-4.036-0.351c0.342,0-5.105,4.393-5.983,3.158
        c-0.875-1.228,0-2.106-0.875-1.228c-0.904,0.878-0.728,4.922-0.728,4.922c1.052,0.706,3.337,3.162,4.922,2.11
        c1.572-1.056,2.454-0.527,2.981-0.357c0.52,0.179-2.454,2.463-4.219,2.463c-1.755,0-7.381,2.108-7.381,2.108
        s-2.461-2.285-2.988-2.459c-0.525-0.176-3.506-0.351-4.033-0.351c-0.525,0-1.231-0.525-1.405,1.054
        c-0.174,1.579,0.174,4.036-1.579,3.685c-1.76-0.353-2.282,0.348-3.165-0.172c-0.878-0.529,1.235-3.165-1.237-3.339
        c-2.459-0.174-3.861-1.93-5.266,0.875c-1.389,2.807-2.249,2.807-0.838,3.343L-29.386-106.604z M-92.987-95.721
        c-0.534,0.887,4.558,1.235,4.907,0.536c0.368-0.71,3.524-0.183,4.223-1.231c0.701-1.056,4.21-3.167,4.737-2.816
        c0.527,0.355-1.052,2.108-1.579,2.287c-0.527,0.174,1.766,0.346-0.527,2.113c-2.278,1.753-1.751,3.339-1.751,3.339
        s-1.932,0.875-0.527,1.228c1.405,0.353,4.038,1.579,4.038,1.579s0.174,1.228,0.174,1.581c0,0.351,0.884,1.405,2.807,0.176
        c1.945-1.231,5.804-2.631,6.331-2.106c0.525,0.525,1.76-0.176,3.522-0.353c1.749-0.172,3.16-0.701,3.16-0.701l2.28,0.353
        c1.056,0.525,1.938-0.701,3.703,0.348c1.747,1.054,4.201,1.054,4.201,1.054s2.465-1.93,2.988-2.104
        c0.529-0.176,1.581-0.351,1.054-1.581c-0.525-1.233-2.457-3.162-1.93-3.524c0.525-0.348,1.753-0.701,1.579-4.036
        s0.351-2.803-0.527-2.631c-0.875,0.176-2.988,1.231-2.988,1.231l-0.697-0.176c-0.348,1.052-1.934,1.755-2.296,2.809
        c-0.348,1.052-1.385,1.579-1.385,0.701c0-0.878-1.235-1.056-1.422-1.758c-0.163-0.703-1.753-0.525-2.629-0.351
        c-0.88,0.174-3.343-1.581-4.223-0.878c-0.869,0.703-1.758-0.348-2.459-1.93c-0.695-1.579-1.579-2.816-2.633-2.646
        c-1.054,0.183-7.553,0-7.553,0l-3.866,0.351c0,0-2.104,0.536-2.104,1.594c0,1.054-0.353,1.758-1.405,2.106
        c-1.061,0.351-8.788,3.16-8.788,3.16S-92.46-96.601-92.987-95.721z M-37.826-99.931l-1.932-0.353c0,0-0.174-1.405-0.699-1.405
        c-0.545,0-2.113,1.932-2.113,1.932s2.289,0.878,2.64,1.581s1.226,1.577,1.226,2.11c0,0.518,5.795-1.76,5.795-1.76l3.171-1.581
        c0,0,0.163,0.351,0.351-0.525c0.176-0.878-0.351-1.579,0-1.758c0.346-0.174,1.753-2.454,0.346-2.104c-1.407,0.344-4.397,0-5.8,0.525
        c-1.405,0.527-3.156-0.697-2.981,0.701c0.163,1.405-0.011,2.635-0.011,2.635H-37.826z M-65.938-108.015c0,0,0.701,2.988,2.113,2.113
        c1.403-0.887,5.438,2.113,5.438,2.454c0,0.362,1.403,0.183,1.403,0.183l6.157-2.115l3.436-0.523c0,0,3.242-0.183,3.764,0.176
        c0.52,0.346,3.169-0.875,3.169-0.875l1.05-1.766l-2.287-0.701l0.534-1.755c0,0-0.708-1.054-2.282,0.174
        c-1.592,1.231-5.978,3.685-5.63,3.165c0.353-0.529-1.751,0.172-2.631-0.884c-0.884-1.05-2.108-1.228-2.108-1.228
        s-2.47-0.875-3.339-0.525c-0.882,0.351,1.579-1.755,1.579-1.755s0.527-1.934-0.536-1.755c-1.043,0.179-9.657,2.108-9.657,2.108
        s-3.689,2.106-4.388,1.577c-0.701-0.525-3.334,0.351-3.334,0.351l1.755,1.054C-71.209-109.072-65.938-108.015-65.938-108.015z
        M-26.762-115.215c0.525,0.17,4.746,1.4,5.273,1.579c0.525,0.179,2.113,0.527,2.803,0.353c0.701-0.174,3.515-1.577,2.468-2.106
        c-1.056-0.525-4.395-1.242-5.098-1.597c-0.701-0.348-3.341-0.514-3.341-0.514l-1.581,0.342c-0.353,0.527-1.059,1.771-0.529,1.943
        L-26.762-115.215z M-43.628-112.23c0.714-0.348,3.169-1.405,3.169-1.405l2.097-1.753l0.71-0.889c0,0-1.579-1.396-2.282-0.88
        c-0.701,0.527-4.402,2.113-4.402,2.113l-0.174,1.231l-2.882,1.235C-47.392-112.578-44.336-111.879-43.628-112.23L-43.628-112.23z
        M-11.987-112.754c0.692,0.176,2.803,0.176,2.979-0.353c0.174-0.527-0.174-4.225-0.174-4.225s-0.71-1.045-1.583-0.871
        c-0.878,0.174-3.685,1.572-3.685,1.572c-0.176,0.534,1.742,3.7,2.47,3.877H-11.987z M-56.37,74.47
        c-0.121-0.39-2.104-1.036-3.156-1.036c-1.054,0-4.878-3.7-5.134-4.492c-0.273-0.792-8.83-2.893-8.83-2.893s-9.357-0.529-9.357-0.787
        c0-0.276-4.483,3.555-4.483,3.555v0.393c0,0,0.386,1.841,0.536,2.238c0.123,0.393,3.026-2.113,3.288-3.162
        c0.262-1.05,2.368-1.321,2.893-1.586c0.536-0.256,0.789,1.065,1.319,1.065c0.534,0,2.904,0.785,2.904,0.785l4.743,1.581l1.844,1.709
        c0,0,0.787,4.208,0.787,4.743c0,0.531,3.559,0.256,3.559,0.256l6.982-0.644C-58.476,76.192-56.228,74.867-56.37,74.47z
        M-56.623,83.302c0.651,0.262,1.702-0.13,2.236-0.13c0.534,0,2.245-0.395,2.245-0.395s0.525,1.186,0.525,1.583
        c0,0.388,2.763-0.137,2.763-0.534s0.659-1.447,0.659-1.447l3.288-0.657c0,0,4.488,0.132,4.88,0.132c0.397,0,0.662-0.789-0.137-2.238
        c-0.783-1.453-3.032-1.724-3.559-2.781c-0.527-1.045-3.026-0.377-3.687,0c-0.657,0.399-4.34-0.909-5.401-0.909
        c-1.045,0,0,1.184,0,1.184l-0.397,3.819h-4.344l-0.135,0.393c0,0-1.189,0.397-1.189,1.189
        C-58.87,83.302-57.289,83.039-56.623,83.302L-56.623,83.302z"
      />
      <g transform="translate(-256.839, -127.234)">
        {data.data.locations.map(({ location }) => {
          const point = getPoint(location);
          return (
            <circle
              key={location.id}
              cx={`${point.x * 100}%`}
              cy={`${point.y * 100}%`}
              r="4"
              fill={theme.colors.accent}
            />
          );
        })}
      </g>
    </svg>
  </div>
);
Map.propTypes = {
  className: PropTypes.string.isRequired,
};

export default fn(__filename, styled(Map)`
  display: flex;
  justify-content: center;

  .stop1 {
    stop-color: #e68600;
  }
  .stop2 {
    stop-color: #000;
  }
`);



// WEBPACK FOOTER //
// ./src/components/icons/Map.js